import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { vxm } from './../store.vuex';

Vue.use(VueI18n);

const messages = {
  en: {
    "lang.label": "Language",
    "lang.en": "English",
    "lang.fr": "French",
    "lang.fr-CA": "French Canadian",
    "lang.de": "German",

    "greeting": "Sign Up",

    //menu
    "menu.top.login": "Login",
    "menu.top.signup": "Sign Up",
    "menu.top.login.signup": "Login/Sign Up",
    "menu.top.referafriend": "Refer a Friend",
    "menu.top.savedjobs": "Saved Jobs",
    "menu.top.findjobs": "Find Jobs",

    // referfriendbox
    "referfriendbox.title": "Refer a Friend and get paid",
    "referfriendbox.button.text": "Refer Now",

    //banner
    "banner.text": "Earn rewards by sharing the app to your friends",

    //social networks
    "social.network.name.apple": "Apple",
    "social.network.name.google": "Google",
    "social.network.name.linkedin": "LinkedIn",
    "social.network.name.facebook": "Facebook",
    

    // login
    "login.welcome_text.emailentry": "Welcome to {companyName}",
    "login.welcome_text.loginform": "Login to {companyName}",
    "login.welcome_text.signup": "Sign up to {companyName}",
    "login.header": "Sign in with",
    "login.email.placeholder": "Enter your email to get started",
    "login.email.required": "Email is required!",
    "login.v2.email.required": "Email required",
    "login.failure": "Login Failure",
    "login.failure.incorrect.password": "Incorrect password. You have one more attempt before your account will be locked",
    "login.failure.invalid.password.v1.msg": "Invalid username or password.",
    "login.failure.invalid.password.v2.msg": "Invalid password.",
    "login.invalid": "Invalid userid/password.",
    "login.email.invalid": "Please enter a valid email address!",
    "login.password.required": "Password is required!",
    "login.rememberme": "Remember me",
    "referral.referralCode.invalid": "Invalid referral code",
    "login.troublelogin": "Trouble logging in?",
    "login.signuplink": "New user? Sign up",
    "login.form.password.placeholder": "Password",
    "login.form.password.show": "Show",
    "login.form.password.hide": "Hide",
    "login.form.email.placeholder": "Email",
    "login.form.button": "Log in",
    "login.form.rememberme": "Remember me",
    "login.form.forgotpassword": "Forgot password?",
    "login.form.send.otpcode": "Send me a one-time passcode instead.",
    "login.form.back": "Back",
    "login.button.continue": "Continue",
    "login.button.continue.socialnetwork": "Continue with {social_network_name}",
    "login.button.cancel": "Cancel",
    //registration
    "registration.header": "Let’s get you hired !",
    "registration.findjobs": "Find jobs",
    "find.jobs.link.text": "Browse more jobs &#8594;",
    "findjobs.button.apply": "Apply",
    //trouble login
    "troublelogin.header": "Trouble logging in?",
    "troublelogin.text": "Please select an option for help.",
    "troublelogin.supportcall.text": "Call us at",
    "troublelogin.emailus": "Email us",

    // Account locked
    "account-locked.title": "Account locked",
    "account-locked.locked-info": "Your account has been locked for security reasons.",
    "account-locked.unlock-info": 'A password reset email has been sent to <strong>{email}</strong>. Use the link in the email or click the <strong>"Reset Password"</strong> button below to unlock your account.',
    "account-locked.reset-btn-text": "Reset password",
    "account-locked.reset-btn-hover-text": "Request unlock",
    "account-locked.toast.codesentmessage": "Verification email sent successfully.",

    //help
    "help.title": "Help",
    "help.learnmore": "Learn more",
    "help.aboutus": "About us",
    "help.learnmore.link.text": "Click here",
    "help.learnmore.text": "to learn more about",
    "help.howitworks": "How it works",
    "help.gotissues": "Got issues?",
    "help.termsofservice": "Terms of service",
    "help.privacypolicy": "Privacy policy",
    "help.callus": "Call us @",
    "help.emailus": "Email us @",
    "help.fortechnicalsupport": "For Technical or App Support:",
    "help.forallother": "For all other (e.g. Job, Pay, etc.) inquiries:",
    "help.contactus": "Contact Us:",
    "help.uscountry": "US:",
    // myprofile
    "myprofile.firstname.required": "First Name is required!",
    "myprofile.lastname.required": "Last Name is required!",
    "myprofile.dob.required": "Date of birth is required!",
    "myprofile.phone.required": "Phone number is required!",
    "myprofile.city.required" : "City is required!",
    "myprofile.postcode.required" : "Post code is required!",
    "myprofile.update.sucess": "Profile Updated Successfully!",
    "changepassword.update.sucess": "Password Updated Successfully!",
    "notificationpreference.update.sucess": "Notification Preference Updated Successfully!",
    "myprofile.update.error": "Unable to Update Profile!",
    "changepassword.update.error": "Unable to Update Password!",
    "notificationpreference.update.error": "Unable to Update Notification Preference!",
    "profile.upload.resume.sucess": "Resume/CV Uploaded Successfully!",
    "profile.upload.resume.error": "Unable to Upload Resume!",
    "profile.upload.resume.file.required": "Please select a resume file",
    "profile.resume.select.required": "Please select a resume",
    "profile.upload.skill.document.file.required": "Please Choose a file",
    "profile.resume.file.name.exceeded": "You have exceeded the maximum character limit of 250 characters for file name",
    "myprofile.oldpassword.required": "Old Password required!",
    "myprofile.newpassword.required": "New Password is required!",
    "myprofile.newpassword.pattern": "Password must be 8 or more characters and have atleast an uppercase letter and a number",
    "myprofile.status.updated": "Updated status successfully",
    "myprofile.message.wrongoldpassword": "Old password entered is wrong",
    "myprofile.button.editprofile": "edit profile",
    "myprofile.button.addlanguage": "Add Language",
    "myprofile.button.addprofessionalreference": "Add Professional Reference",
    "myprofile.button.workpreference": "Edit Work Preference",
    "myprofile.button.addeducationhistory": "Add Education History",
    "myprofile.button.editnotification": "edit notification preferences",
    "myprofile.button.changepassword": "change password",
    "myprofile.button.cancel": "Cancel",
    "myprofile.button.update": "Update",
    "myprofile.button.save": "save",
    "myprofile.label.firstname": "First name",
    "myprofile.label.lastname": "Last name",
    "myprofile.label.preferredname": "Preferred name",
    "myprofile.label.adress": "Address",
    "myprofile.label.phoneNumber": "Phone",
    "myprofile.label.email": "Email",
    "myprofile.label.password": "Password",
    "myprofile.label.oldpassword": "Old Password",
    "myprofile.label.newpassword": "New Password",
    "myprofile.label.confirmnewpassword": "Confirm New Password",
    "myprofile.label.passwordrequirements": "Password Requirements",
    "myprofile.label.minchars": " Minimum 8 characters",
    "myprofile.label.upperchars": " Atleast 1 number and 1 Uppercase character",
    "myprofile.menu.label.profile": "Profile",
    "myprofile.menu.label.jobhistory": "Job History",
    "myprofile.menu.label.skills": "Job Skill / Specialty",
    "myprofile.menu.label.resume": "Resume/CV",
    "myprofile.menu.label.resumeCV": "Resume/CV",
    "myprofile.label.desiredlocation": "Desired Work Location(s)",
    "myprofile.label.desiredsalary": "Desired Salary",
    "myprofile.label.jobavailability": "Available to Start Work",
    "myprofile.label.jobSearchStatus": "Job Search Status",
    "myprofile.label.remotework": "Remote Preference",
    "myprofile.label.dob": "Date of Birth",
    "myprofile.updatepassword.socialmediaaccount.errormessage": "You have registered through social media. Please change your social media password.",
    "myprofile.label.race": "Race",
    "myprofile.label.ethinicity": "Ethinicity",
    "myprofile.label.gender": "Gender",
    "myprofile.label.personalpronouns": "Personal Pronouns",
    "myprofile.skill.yearofexperience.min.valid": "The min value for Year of Experience must be {min_value}",
    "myprofile.skill.yearofexperience.max.valid": "The max value for Year of Experience must be {max_value}",
    "myprofile.skill.yearofexperience.text": "None | {yoe} year | {yoe} years",
    // sign up
    "signup.signupwith": "Sign up with",
    "signup.completesignup": "Complete registration with {socialRegistrationType}",
    "signup.firstname.required": "First name is required!",
    "signup.lastname.required": "Last name is required!",
    "signup.firstname.invalid": "First name should only contain alphabets and special characters (-'.,) with maximum 50 characters",
    "signup.lastname.invalid": "Last name should only contain alphabets and special characters (-'.,) with maximum 50 characters",
    "signup.phone.required": "Phone number is required!",
    "signup.phone.valid": "Please enter a valid phone number!",
    "signup.email.required": "Email is required!",
    "signup.enter.valid.email": "Please enter a valid email address!",
    "signup.password.required": "Password is required!",
    "signup.password.confirmation.equivalent": "Passwords entered do not match. Please retype.",
    "signup.password.length": "Password and confirmation password must be equivalent!",
    "signup.phone.duplicate": "New phone number must be different than existing number.",
    "signup.password.contain.character.number": "Password must be minimum 8 characters, must contain at least one upper-case letter and a number",
    "signup.password.helptext": "Passwords must contain a minimum of 8 characters and include an uppercase letter and a number",
    "signup.terms.services": "By checking this box, I agree to the <a class='font-weight-bold' href='{termsOfServiceURL}' target='_blank'>Terms of Service</a> and  <a class='font-weight-bold' href='{privacyPolicyURL}' target='_blank'>Privacy Policy</a>. I also consent to receive communications from {companyName} to any of the methods of contact provided in my account, including email, calls, SMS, or other messaging applications. I can withdraw this consent at any time by changing the preferences in my account profile or following the instructions in the communication.",
    "quickjobapply.terms.service": "By applying to this job you are creating an account and agree to the <a class='font-weight-bold' href='{termsOfServiceURL}' target='_blank'>terms of service</a> and  <a class='font-weight-bold' href='{privacyPolicyURL}' target='_blank'>privacy policy.</a>",

    //Engineer Signup/Registration
    "signup.resume.required": "Please select a resume!",
    "signup.form.button.signup": "Sign up",
    "signup.form.button.submit": "Submit",
    "signup.form.button.cancel": "Cancel",

    "signup.mostCurrentAirframe.required": "Latest airframe is required!",
    "signup.latestrank.required": "Latest rank is required!",
    "signup.employer.required": "Latest/current company is required!",
    "signup.currentengine.required": "Current engine type is required!",

    "signup.engineType.required": "Engine type is required!",
    "signup.licenceType.required": "Licence type is required!",
    "signup.licenceAuthority.required": "Licence authority is required!",
    "signup.licencecountry.required": "Licence country is required!",

    "signup.passport.required": "Passport country is required!",
    "signup.otherPassport.required": "Other passport country is required!",
    "signup.othetRecentAirframe.required": "Other recent airframe is required!",
    //Other role signup
    "signup.currentJobTitle.required": "Current job title is required!",

    // forgot password
    "forgotpassword.email.required": "Email is required!",
    "forgotpassword.enter.valid.email": "Please enter a valid email address!",
    "forgotpassword.header": "Forgot password?",
    "forgotpassword.subheader": "Don’t worry we’ll help you reset your password.",
    "forgotpassword.cancel": "Cancel",
    "forgotpassword.go.to.login": "Back to log in",
    "forgotpassword.socialmedia.errormessage": "You have registered through social media. Login using the social media icon you used to register.",
    "forgotpassword.send.passcode.button": "Send passcode",
    "forgotpassword.additional.msg.email": "Still need help?  Please reach out to us at <a href='mailto:{email}' target='_blank'>{email}</a>",
    "forgotpassword.additional.msg.mobile": " or <a href='tel:{phone}' target='_blank'>{phone}</a>",

    // verification
    "verification.header": "Code Verification",
    "verification.subheader": "We've texted your phone {phoneNumber}.",
    "verification.entercode": "Please enter the code to sign in.",
    "verification.validation": "Enter the 5 digit code we texted you to continue",
    "verification.emailverification": "We verify your email to make sure potential employers have the best information to contact you.",
    "verification.timetakenmessage": "Please keep in mind. The validation code can take up to 5 minutes to send.",
    "verification.continue": "continue",
    "verification.skipverification": "Skip verification",
    "verification.resendcode": "Resend code?",
    "verification.otp.validation.message": "Please enter the 5 digit code to continue",
    "verification.toast.title": "Validation",
    "otp-login.header": "Check your email",
    "otp-login.subheader": "We’ve sent a verification code to",
    "otp-login.timetakenmessage": "It can take up to 5 minutes for the code to show up in your",
    "otp-login.confirm-btn": "Continue",
    "otp-login.back-btn": "Back to log in",
    "otp-login.entercode": "Enter the 5-digit code to continue",
    "otp-login.invalidcode": "Invalid code.",
    "otp-login.resendcode": "Resend Now",
    "otp-login.toast.title": "",
    "otp-login.toast.codesentmessage": "Verification email sent successfully.",
    "opt-login.resendcode": "You can resend the code in",
    "changenumber.toast.title": "Change phone number",
    "updatephoneverification.subheader": "Enter your new phone number below",
    "updatephoneverification.success": "Success! Your phone number has been changed.",
    "updatephone.displaytext": "We'll send a verification code to your new phone number. Enter the code on the next screen to complete your phone number change.",
    "otp-login-success.title": "Success!",
    "otp-login-success.go-to-home-btn-text": "Skip and continue to account",
    "otp-login-success.reset-password-link-text": "Reset your password now",

    // change password
    "changepassword.current.password.required": "Current password is required!",
    "changepassword.new.password.required": "New password is required!",
    "changepassword.confirn.password.required": "Confirm password is required!",
    "changepassword.success.message": "Password successfully reset! A temporary password has been sent to your email address. Please use the temporary password to login. If you cannot find the mail, check the Junk or Spam folder",

    // Change password V2
    "changepassword.v2.title": "Set a new password",
    "changepassword.v2.passwordrequirements": "Minimum 8 characters, 1 uppercase letter and a number.",
    "changepassword.v2.label.newpassword": "Password",
    "changepassword.v2.label.confirmnewpassword": "Re-enter your password",
    "changepassword.v2.password.show": "Show",
    "changepassword.v2.password.hide": "Hide",
    "changepassword.v2.button.confirm": "Set password",
    "changepassword.v2.button.cancel": "Cancel",
    "changepassword.v2.update.sucess": "Password successfully updated.",
    "changepassword.v2.update.error": "Unable to update password!",
    "changepassword.v2.min_length": " | Minimum {n} character | Minimum {n} characters",
    "changepassword.v2.uppercase_chars": " | {n} uppercase letter | {n} uppercase letters",
    "changepassword.v2.numbers_chars": " | {n} number | {n} numbers",
    "changepassword.v2.special_chars": " | {n} special character | {n} special characters",

    // jobshare
    "jobshare.fullname.required": "Full Name is required!",
    "jobshare.email.required": "Please provide email or mobile number!",
    "jobshare.enter.valid.email.phone": "Please enter a valid email or mobile number!",
    "jobshare.enter.valid.email": "Please enter a valid email address!",
    "jobshare.phone.valid": "Please enter a valid Phone number!",
    "jobshare.enter.recaptcha.response": "Please confirm that you are not a robot!",
    "invite.email.success": "Thanks for referring! Your referral emails have been sent!",
    "verfication.otp.success": "Verification Done Successfully!",

    // quick register user
    "quicksignup.firstname.required": "First name is required!",
    "quicksignup.lastname.required": "Last name is required!",
    "quicksignup.email.required": "email is required!",
    "quicksignup.phone.valid": "Please enter a valid Phone number!",
    "quicksignup.enter.valid.email": "Please enter a valid email address!",
    "quicksignup.enter.recaptcha.response": "Please confirm that you are not a robot!",
    // refer a friend
    "referinternalfriend.title": "Refer a Friend for Internal Recruiting and Sales Positions",
    "referafriendexternal.title": "Refer a Friend for External Customer Projects",
    "referafriend.title": "Refer a Friend",
    "referafriend.friendinfo.form.title": "Enter your friend's Info",
    "referafriend.userinfo.form.title": "Enter your Info",
    "referafriend.selectrecruiter.form.title": "Select your recruiter (If applicable)",
    "referafriend.firstname.required": "First Name is required!",
    "referafriend.lastname.required": "Last Name is required!",
    "referafriend.email.required": "Email is required!",
    "referafriend.phone.required": "Phone number is required!",
    "referafriend.phone.valid": "Please enter a valid Phone number!",
    "referafriend.enter.valid.email": "Please enter a valid email address!",
    "referafriend.address.valid": "Address is required!",
    "referafriend.role.valid": "Please select role!",
    "referafriend.form.firstname": "First Name*",
    "referafriend.form.lastname": "Last Name*",
    "referafriend.form.email": "Email*",
    "referafriend.form.mobile": "Mobile",
    "referafriend.form.recruiterselect": "Enter 3 characters to select a recruiter",
    "referafriend.form.submit": "Submit",
    "referafriend.modal.body": "Your referral was successfully submitted. Thanks for referring! You can inform your friend of this referral via email. Click Ok",
    "referafriend.form.submit.failure": "Error processing refer a friend request",
    "referafriend.modal.header": "Referral alert",
    "referafriend.form.submit.success.message": "Refer a friend",
    "referafriend.form.submit.success.message.without.bonus": "Referral successfully submitted. Thank you!",
    "referafriend.form.submit.success.title": "Your referral was successfully submitted. You can inform your friend of this referral via email.",
    //my referrals
    "myreferrals.header": "My Referrals/ Promote {companyName}",
    "myreferrals.myreferrals": "My Referrals",
    "myreferrals.promotecompany": "Promote {companyName}",
    "myreferrals.appreferral": "App referral",
    "myreferrals.friendreferral": "Friend referral",
    "myreferrals.jobreferral": "Job referral",
    "myreferrals.jobstatus": "Job status:",
    "myreferrals.recruitername": " Recruiter: {recruiterName}",
    "myreferrals.nodata": "No data to show",
    "myreferrals.refercompany": "Refer {companyName}",
    "myreferrals.refermessage": "Invite your friends by sharing this code on social media",
    "myreferrals.refernow": "Refer now",
    "myreferrals.viewtandc": "View Terms & Condition",
    "myreferrals.viewed": "viewed",
    "myreferrals.referred": "referred",
    "myreferrals.signedup": "signed up",
    "myreferrals.applied": "applied",
    "myreferrals.hired": "hired",
    "myreferrals.empty.message": "You don’t have any Referrals right now",
    //app referral
    "appreferral.title": " {Referrer} has invited you to try {candidatePortalApplicationName}",
    "appreferral.description": "Earn referral bonus by referring jobs using the {candidatePortalApplicationName} App! Refer as many friends and jobs as you like!",
    "appreferral.description.withoutbonus": "Welcome to {candidatePortalApplicationName}!",
    "appreferral.desktop.message": "Sign up now to browse jobs, manage & track your applications, and create job alerts that matches your interests!",
    "appreferral.location.placeholder": "Enter your location",
    "appreferrals.jobs.button.text": "See jobs nearby",
    "appreferrals.signup.link": "New user? Sign up",
    "appreferrals.refer.link": "Refer a friend",
    "appreferrals.expired.referral.job" : "This invite link has expired",
    "appreferrals.expired.message.desktop" : "{Referrer} invite to join {candidatePortalApplicationName} is no longer valid. Invite links expire after a set period for security. You can still create your account directly below.",

    //invite
    "invite.google.contact.list.header": "Select your google contacts",
    "invite.google.contact.list.search.label": "Search contacts",
    "invite.google.contact.nodata": "No Contacts to display",
    "invite.findjobs.btn.text": "Find jobs",
    "invite.card.header": "Invite your friends",
    "invite.importcontact.btn.text": "Lookup Google Contacts",
    "invite.textarea.header": "Email (Separate with comma)",
    "invite.share": "Share",
    "invite.tweet": "Tweet",
    "invite.copylink": "Copy link",
    "invite.sendemail": "Send email",
    "invite.or": "or",
    //footer
    "footer.copyright": "Copyright © WorkLLama LLC",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",

    //Job Alert
    "jobalert.title": "Job Alerts",
    "jobalert.button.createalert": "create alert",
    "jobalert.button.getalertsbutton": "Get alerts",
    "jobalert.button.newsearch": "Start a new search",
    "jobalert.button.save": "save",
    "jobalert.button.cancel": "Cancel",
    "jobalert.button.saveasalert": "Save as Alert",
    "jobalert.button.updatealert": "Update alert",
    "jobalert.button.savealert": "Save alert",
    "jobalert.button.seealljobs": "Show matching jobs",
    "Password-entered-does-not-match-with-records" : "Password entered does not match with records",
    "jobalert.label.noalerts": "You don’t have any saved alerts right now.",
    "jobalert.label.createalerts": "Once you set-up job alerts, we'll keep you updated through email or text and save all your notifications here.",
    "jobalert.label.location": "Location",
    "jobalert.label.jobtitle": "Job Title/ Description or Company",
    "jobalert.label.savedalerts": "Saved Alerts",
    "jobalert.label.createnewalerts": "Create new alerts",
    "jobalert.label.remoteworkingjob": "Remote Job",
    "jobalert.label.filterremoteworkingjobs": "Remote Jobs",
    "jobalert.label.allowsremoteworking": "Allows Remote Work",
    "jobalert.label.jobAlertName": "Name of your job alert",
    "jobalert.label.alertName": "Alert Name",
    "jobalert.label.createJobAlertName": "Name your job alert",
    "jobalert.label.pauseNotificationText": "Alert will be paused when disabled",
    "jobalert.label.NotificationPopup.SMS": "You have your SMS notification preference set to off. This will activate SMS notification for all",
    "jobalert.label.NotificationPopup.Push": "You have your Push notification preference set to off. This will activate Push notification for all",
    "jobalert.label.NotificationPopup.Email": "You have your Email notification preference set to off. This will activate Email notification for all",
    "jobalert.label.NotificationPopup.Email.SMS": "You have your Email and SMS notification preferences set to off. This will activate Email and SMS notifications for all",
    "jobalert.label.NotificationPopup.Email.Push": "You have your Email and Push notification preferences set to off. This will activate Email and Push notifications for all",
    "jobalert.label.NotificationPopup.SMS.Push": "You have your SMS and Push notification preferences set to off. This will activate SMS and Push notifications for all",
    "jobalert.label.NotificationPopup.Email.SMS.Push": "You have your Email, SMS and Push notification preferences set to off. This will activate Email, SMS and Push notifications for all",
    "jobalert.label.notification": "Get notified via",
    "jobalert.label.notificationMode1": "Email",
    "jobalert.label.notificationMode2": "SMS",
    "jobalert.label.notificationMode3": "Push",
    "jobalert.label.frequency": "Frequency",
    "jobalert.label.frequencyMode1": "Daily",
    "jobalert.label.frequencyMode2": "Weekly",
    "jobalert.label.frequencyMode3": "Monthly",
    "jobalert.label.managefrequency": "Manage Frequency",
    "jobalert.label.emailfrequency": "Email Frequency",
    "jobalert.create.defaultjobalertname": "My saved alert",
    "jobalert.label.create": "Create Job Alert",
    "jobalert.label.fullName": "Full Name",
    "jobalert.label.Email": "Email",
    "jobalert.label.searchCriteria": "Serach Criteria",
    "jobalert.label.jobType": "Job Type",
    "jobalert.label.jobSkills": "Job Skills",
    "jobalert.label.industry": "Industry",
    "jobalert.label.industryType": "Industry Type",
    "jobalert.label.confirmationCheck": "I want to receive daily e-mail updates pertaining to this alert",
    "jobalert.label.remoteJobsSelectedOptions": "Remote Jobs: {options}",
    "jobalert.label.yes": "Yes",
    "jobalert.label.no": "No",
    "jobalert.label.partial": "Partial",


    //mobile banner
    "banner.app.install": "Install",

    //Job Seeker
    "jobseeker.label.uploadpicture": "Upload a picture",
    "jobseeker.label.cancel": "Cancel",
    "jobseeker.label.online": "Online",
    "jobseeker.label.donotdisturb": "Do not disturb",
    "jobseeker.label.profilestrength": "Profile Strength",
    "jobseeker.button.save": "save",
    "jobseeker.button.cancel": "cancel",

    //JobHistory
    "userjobhistory.label.jobrole": "Job Title",
    "userjobhistory.label.location": "Job Location",
    "userjobhistory.label.companyname": "Company Name / Facility Name",
    "userjobhistory.label.jobtype": "Job Type",
    "userjobhistory.label.parttime": "Part Time",
    "userjobhistory.label.fulltime": "Full Time",
    "userjobhistory.label.startdate": "Start Date",
    "userjobhistory.label.enddate": "End Date",
    "userjobhistory.label.currentlyworkhere": "Currently Work Here",
    "userjobhistory.label.reasonForLeaving": "Reason for Leaving",
    "userjobhistory.label.reasonForLeavingPlaceholder": "Select the reason",
    "userjobhistory.label.supervisorName": "Supervisor Name",
    "userjobhistory.label.supervisorPhone": "Supervisor Phone",
    "userjobhistory.label.permissionToContactSupervisor": "Permission to contact supervisor",
    "userjobhistory.label.chargeExperience": "Charge Experience",
    "userjobhistory.label.traumaLevel": "Trauma Level",
    "userjobhistory.button.cancel": "Cancel",
    "userjobhistory.button.update": "update",
    "userjobhistory.button.save": "save",
    "userjobhistory.button.addjobhistory": "Add Work Experience",
    "userjobhistory.status.approved": "Approved",
    "userjobhistory.status.pendingapproval": "Pending Approval",
    "userjobhistory.status.unverified": "UnVerified",
    "userjobhistory.status.deniedapproval": "Denied Approval",
    //Passport
    "passport.button.editpassport": "Edit Passport",
    "passport.button.addpassport": "Add Passport",
    "passport.button.upload": "upload",
    "passport.button.save": "save",
    "passport.button.cancel": "cancel",
    "passport.button.replace": "replace",
    "passport.label.currentpassport": "Current passport",
    "passport.label.supportingdocuments": "Supporting Documents",
    "passport.label.effectivedate": "Effective Date",
    "passport.label.expirydate": "Expiry Date",
    "passport.label.doesnotexpire": "Does not expire",
    "passport.label.view": "View",
    "passport.label.edit": "Edit",
    "passport.label.download": "Download",
    "passport.label.delete": "Delete",
    "passport.label.addnewpassport": "Add New Passport",
    "passport.label.expandall": "EXPAND ALL",
    "passport.label.collapseall": "COLLAPSE ALL",
    "passport.label.supportingdocumentsforthispassport": "Supporting documents for this Passport",
    "passport.label.skipfornow": "Skip for now",
    "passport.label.addsupportingdcouments": "Add supporting documents for this passport",
    "passport.label.addsupportingdcoumentsheading": "Please upload the required/necessary documents for the passport you are about to add. You can also choose to add it later under the supporting documents section in the main passport page",
    "passport.label.format": "File format allowed are .doc,.docx,.pdf,.txt. Max file size:10MB",
    "passport.label.documentexpires": "This document does not expire",
    "passport.label.addsupportingdcoumentsmulti": "Add supporting document details for the passport",
    "passport.label.addsupportingdcoumentspassport": "Please add the document details for the passport",
    "passport.label.uploadeddocument": "Uploaded document",
    "passport.label.documentdoesnotexpire": "This document does not expire",
    "passport.label.fromdropbox": "from dropbox",

    //License
    "licence.button.editlicence": "Edit Licence",
    "licence.button.addlicence": "add licence",
    "licence.button.upload": "upload",
    "licence.button.save": "save",
    "licence.button.cancel": "cancel",
    "licence.button.replace": "replace",
    "licence.label.currentlicence": "Current licence(s) :",
    "licence.label.supportingdocuments": "Supporting Document(s)",
    "licence.label.effectivedate": "Effective Date",
    "licence.label.expirydate": "Expiry Date",
    "licence.label.doesnotexpire": "Does not expire",
    "licence.label.view": "View",
    "licence.label.edit": "Edit",
    "licence.label.download": "Download",
    "licence.label.delete": "Delete",
    "licence.label.addnewlicence": "Add New Licence(s)",
    "licence.label.expandall": "EXPAND ALL",
    "licence.label.collapseall": "COLLAPSE ALL",
    "licence.label.supportingdocumentsforthislicence": "Supporting documents for this licence",
    "licence.label.skipfornow": "Skip for now",
    "licence.label.addsupportingdcouments": "Add supporting documents for this licence",
    "licence.label.addsupportingdcoumentsheading": "Please upload the required/necessary documents for the licence you are about to add. You can also choose to add it later under the supporting documents section in the main licence page",
    "licence.label.format": "File format allowed are .doc,.docx,.pdf,.txt. Max file size:10MB",
    "licence.label.documentexpires": "This document does not expire",
    "licence.label.addsupportingdcoumentsmulti": "Add supporting document for the Licence",
    "licence.label.addsupportingdcoumentslicence": "Please upload the required/necessary document for the licence",
    "licence.label.uploadeddocument": "Uploaded document",
    "licence.label.documentdoesnotexpire": "This document does not expire",
    "licence.label.fromdropbox": "from dropbox",

    //Skills
    "skills.section.title": "Skills/Specialty(s)",
    "skill.success.message.title": "Skills",
    "skill.success.message": "Skill Selected Successfully",
    "skills.button.header.text": "No skills/specialty(s) added yet",
    "skills.button.sub.header.text": "Please add skills/specialty(s) to your profile",
    "skills.button.editskills": "Edit Skills / Specialty",
    "skills.button.addkills": "Add Skills/Specialty(s)",
    "skills.button.upload": "upload",
    "skills.button.save": "save",
    "skills.button.cancel": "cancel",
    "skills.button.replace": "replace",
    "skills.label.currentkills": "Current Skills / Specialty",
    "skills.label.supportingdocuments": "Supporting Documents",
    "skills.label.effectivedate": "Effective Date",
    "skills.label.expirydate": "Expiry Date",
    "skills.label.doesnotexpire": "Does not expire",
    "skills.label.view": "View",
    "skills.label.edit": "Edit",
    "skills.label.download": "Download",
    "skills.label.delete": "Delete",
    "skills.label.addnewskills": "Add New Skills/Specialty(s)",
    "skills.label.expandall": "EXPAND ALL",
    "skills.label.collapseall": "COLLAPSE ALL",
    "skills.label.supportingdocumentsforthiskill": "Supporting documents for this skill",
    "skills.label.skipfornow": "Skip for now",
    "skills.label.addsupportingdcoumentsforthiskill": "Add supporting documents for this skill",
    "skills.label.addsupportingdcoumentsheading": "Please upload the required/necessary documents for the skills you are about to add. You can also choose to add it later under the supporting documents section in the main skills page",
    "skills.label.format": "File format allowed are .doc,.docx,.pdf,.txt. Max file size:10MB",
    "skills.label.documentexpires": "This document does not expire",
    "skills.label.addsupportingdcoumentsmulti": "Add supporting document for the skill(s)",
    "skills.label.addsupportingdcoumentsskills": "Please upload the required/necessary document for the skills",
    "skills.label.uploadeddocument": "Uploaded document",
    "skills.label.documentdoesnotexpire": "This document does not expire",
    "skills.label.fromdropbox": "from dropbox",
    "skills.checklist.info": "This checklist is a self-assessment and is meant to serve as a general guidance for our client facilities as to the level of your skills within your speciality. Please use the scale below to describe your experience/expertise in each area listed below.",

    //Resum
    "resume.button.uploadresume": "Upload Resume/CV...",
    "resume.button.addresume": "Add Resume/CV",
    "resume.button.upload": "upload",
    "resume.button.cancel": "cancel",
    "resume.button.rename": "Rename",
    "resume.button.save": "save",
    "resume.label.uploadfromdropbbox": "Upload from dropbox",
    "resume.label.formatsallowed": "Allowed file formats: {allowedFormats}",
    "resume.label.default": "Default",
    "resume.label.makedefault": "Make Default",
    "resume.label.rename": "Rename",
    "resume.label.download": "Download",
    "resume.label.delete": "Delete",
    "resume.label.renameresume": "Rename Resume/CV",
    "resume.label.view": "View",

    //JobAlert Activation/DeActivation
    "jobalert.validation.error": "Job Alert Activation Error",
    "jobalert.validation.success": "Job Alert Activated",
    "jobalert.validation.signupinfo": "You can manage your job alerts by creating an account at the link below.",
    "jobalert.validation.signuplink": "Sign Up",

    "jobalert.deactivation.error": "Job Alert Deactivation Error",
    "jobalert.deactivation.success": "Job Alert Deactivated",

    //Guided Signup
    "guidedsignup.resume.header": "Add a Resume/CV",
    "guidedsignup.resume.subheader": "Adding a resume helps kickstart your profile",
    "guidedsignup.user-address.header": "Add your Address",
    "guidedsignup.user-address.subheader": "This will help us recommend jobs near you",
    "guidedsignup.work-experience.header": "Add your Work Experience",
    "guidedsignup.work-experience.subheader": "Let recruiters know about your past work experience",
    "guidedsignup.skills.header": "Add your Skills & Specialties",
    "guidedsignup.skills.subheader": "Adding your Skills & Specialties is a great way to strengthen your profile",
    "guidedsignup.my-documents.header": "Add Credentials",
    "guidedsignup.my-documents.subheader": "Upload applicable certifications, vaccinations, tests, etc.",
    "guidedsignup.profile-picture.header": "Add a Profile Picture",
    "guidedsignup.profile-picture.subheader": "Add some style to your profile with your picture or an avatar",
    "guidedsignup.final.header": "Woohoo! Great Job!",
    "guidedsignup.final.subheader": "Your profile is all set! Let's find opportunities for you",
    "guidedsignup.exit.confirmation.header": "Update profile later?",
    "guidedsignup.exit.confirmation.message": "Go to View Profile to update your profile",
    "guidedsignup.professional-reference.header": "Add your Professional References",
    "guidedsignup.professional-reference.subheader": "Let us know who we can contact to learn a little more about you",
    "guidedsignup.certification-questioner.header": "Certification Questions",
    "guidedsignup.certification-questioner.subheader": "Answer these questions to finalize your profile",
    "guidedsignup.education-history.header": "Add your Education History",
    "guidedsignup.education-history.subheader": "Got any degrees or certifications? Show them off here",
    "guidedsignup.user-preference.header": "Add your Work Preferences",
    "guidedsignup.user-preference.subheader": "This helps us recommend better jobs for you",
    "guidedsignup.additional-documents.header": "Add your Additional Documents",
    "guidedsignup.additional-documents.subheader": "Got any other documents to upload? Add them here",
    "guidedsignup.source-type.header": "Select your Source(s)",
    "guidedsignup.source-type.subheader": "Let us know how you heard about us",
    "guidedsignup.language.header": "Add your Language(s)",
    "guidedsignup.language.subheader": "Let us know which language(s) you speak",
    "guidedsignup.personal_info.header": "Add your Personal Info",
    "guidedsignup.personal_info.subheader": "Enter some of your basic information here",
    "guidedsignup.protected_information.header": "Add your Protected Info",
    "guidedsignup.protected_information.subheader": "Help us by answering a few of these questions",
    "guidedsignup.passport.header": "Add your Passport",
    "guidedsignup.passport.subheader": "Please provide us your passport information",
    "guidedsignup.license.header": "Add your License",
    "guidedsignup.license.subheader": "Please provide us your license information",
    "guidedsignup.were-you-referred.header": "Were you Referred?",
    "guidedsignup.were-you-referred.subheader": "Please let us know if someone helped you find out about us.",
    "guidedsignup.save-and-exit.header": "Save & Exit",
    "guidedsignup.save-and-exit.subheader": "",

    "otp.verification.message": "We verify your mobile number to make sure potential employers have the best information to contact you.",
    "myprofile.address.city": "City",
    "myprofile.address.state": "State",
    "myprofile.address.zip": "Postal Code",

    // forum
    "forum.post.comment": "Comment | Comments",
    "forum.welcome.title": "{welcomeTitle} Forum",

    //Job Role Signup
    "pilotsignup.totalhours.helptext": "This total is for all airlines on this fleet & in this rank",
    "jobrolesignup.pilot.dateofbirth.required": "Date of birth is required!",
    "jobrolesignup.pilot.hoursOnTypeInRank.required": "Hours on type in rank is required!",
    "jobrolesignup.pilot.totalHours.required": "Total flight hours is required!",
    "jobrolesignup.pilot.countryOfPassport.required": "Country of passport is required!",
    "jobrolesignup.pilot.latestFleet.required": "Latest fleet is required!",
    "jobrolesignup.pilot.latestRank.required": "Latest rank is required!",
    "jobrolesignup.pilot.countryOfLicense.required": "Country of licence is required!",
    "jobrolesignup.pilot.typeOfLicense.required": "Type of licence is required!",
    "jobrolesignup.pilot.licenceAuthority.required": "Licence authority is required!",
    "jobrolesignup.pilot.latestAirlineCompany.required": "Latest airline/company is required!",
    "jobrolesignup.pilot.lastFlightDate.required": "Date of last flight is required!",
    "jobrolesignup.pilot.otherNonFlyingPosition.required": "Other non flying position is required!",

    //Credentials
    "myprofile.my-documents.header": "My documents",
    "myprofile.my-documents.credentials.header": "Credentials",
    "myprofile.my-documents.credentials.subheader": "Documents required for working in your profession and applying for jobs.",
    "myprofile.my-documents.additionaldocuments.header": "Additional documents",
    "myprofile.my-documents.additionaldocuments.subheader": "Any other documents that you would like to showcase or store in your profile.",
    "myprofile.my-document.credential-upload.header": "Upload your credential",

    //Additional Documents
    "myprofile.additionaldocuments.landing.notadditionaldocumentsadded": "No additional document(s) added yet",
    "myprofile.additionaldocuments.landing.addaditonaldocuments": "Please add additional document(s) to your profile",
    "myprofile.additionaldocuments.landing.addaditonaldocumentslink": "Add Additional Document(s)",
    "myprofile.additionaldocuments.button.adddocuments": "Add document",
    "myprofile.additionaldocuments.header": "Add Additional document(s)",
    "myprofile.additionaldocuments.headerdesc": "Please add additional documents that has no connection with the skills here.",
    "myprofile.additionaldocuments.addlink": "+ Add Additional Document(s)",

    //My Profile Social Profile
    "socialprofile.profilelink.invalidurl": "Please enter a valid web address that includes https://",// "Please enter a valid URL address",
    "socialprofile.profilelink.invalid": "Please provide selected platform link",
    "socialprofile.profileedit.heading": "Social Profiles",
    "socialprofile.profileedit.tag": "Where can people find you online?",
    "socialprofile.profileedit.addnew": "Add new",
    "socialprofile.button.add": "+ADD",
    "socialprofile.profile.error": "Please correct error(s) in social profile section",
    "socialprofile.profilelink.urlexists": "Given URL already exists",
    "socialprofile.profile.emptyprofiles": "Add at least one social profile using the + button",
    "socialprofile.header": "No social profile added yet",
    "socialprofile.subheader": "Please add your social profiles or your website links",
    "socialprofile.edit": "edit social profiles",
    "socialprofile.select": "Select",
    "socialprofile.add.website.url": "ex: https://www.{socialprofile}.com/myaccount",
    "socialprofile.add.social.profile": "Add Social Profile",

    //Provisory filters matching
    "JobPosting.searchField": "Job Title",
    "Facility.location": "Location",
    "Facility.radius": "Radius",
    "JobPosting.jobPostingType": "Job Type",
    "IndustryVertical.industryVerticalId": "Industry",
    "SkillType.skillTypeId": "Job Skills/Specialty",
    "JobPosting.remoteJobType": "Remote Jobs",
    "JobPosting.jobTags": "Job Tags",
    "JobPosting.jobPayRateHigh": "Salary",

    // find jobs
    "findjobs.button.refer": "Refer",
    "findjobs.text.viewReferralDetails": "View Referral Details",

    //document
    "document-name": "Document Name",
    "document-type": "Document Type",
    "document-select-doc-type": "Select Document Type",
    "document-placeholder-enter-name": "Enter Name",
    "placeholder-select-file": "Upload Resume/CV",
    "document-resume-placeholder":"Upload Supporting Document",
    "document-allowed-file-format": " Allowed file formats: {allowedDocumentFormatText} Max file size: {maxFileSize}MB",

    // resume
    "resume-add-a-resume-text": "Add a Resume/CV",
    "resume-subheader-text": "Adding a resume helps kickstart your profile",

    //Languages
    "languages-no-languages": "No Language(s) added yet",
    "add-languages.text": "Add Language(s) you speak",
    "no-languages-found-text": "No languages found",
    "languages-search-language": "Search for languages you speak",
    "languages.add.langages": "Add Language(s)",


    //Education History
    "educationHistory-no-education-history": "No education history added yet",
    "educationHistory-add-education-history-text": "Please add an education history to your profile",
    "educationHistory-add-education-history-btn": "+ Add Education History",
    "education-history-school-uni": "School or University",
    "placeholder-school": "Please enter school",
    "education-history-degree": "Degree",
    "education-history-select-degree": "Select degree",
    "education-history-gpa": "Overall Result (GPA)",
    "placeholder-location": "Location",
    "placeholder-field-of-study": "Field of Study (Major)",
    "cancel.btn": "Cancel",
    "save.btn": "Save",

    //work preference
    "workPreference-please-select": "Please Select",
    "workPreference-select-from-dropdown": "Select dropdown item",
    "workPreference-select-timeRange": "Select Time range",
    "workPreference-start-end-time-is-same": "Start time and end time is same. Please select different time.",
    "workPreference-willing-to-relocate": "Willing to Relocate?",
    "workPreference-gross-pay": "Gross Pay",
    "workpreference.completed.jobs": "Jobs you are on or completed will show here",
    "workpreference.minsal.greater.than.maxsal": "Minimum salary should not be greater than max salary",
    // professional references
    "professionalReferences-no-professionalReference": "No professional references added yet",
    "professionalReferences-add-professionalReference": "Please add a professional reference to your profile",
    "professionalReferences-details-updated": "Professional Reference details has been updated",
    "professionalReferences-details-saved": "Professional Reference details has been saved",
    "professionalReferences-details-deleted": "Professional Reference details deleted successfully.",
    "professionalReferences-first.name.required": "Reference First Name is required",
    "professionalReferences-last.name.required": "Reference Last Name is required",
    "professionalReferences-email.required": "Reference Email is required",
    "professionalReferences-company.required": "Company is required",
    "professionalReferences-phone.number.required": "Reference Phone is required",
    "professionalReferences-myjob.required": "My Job Title is required",
    "professionalReferences-reference.jobtitle.required": "Reference Job Title is required",
    "professionalReferences-location.required": "Location is required",
    "professionalReferences-from.date.required": "From Date is required",
    "professionalReferences-to.date.required": "To Date is required",
    "professionalReferences-concent.required": "Please provide consent",
    "professionalReferences-relationship.required": "Relationship is required",
    "professionalReferences-Salutation.required": "Salutation is required",
    "professionalReferences-reference.required": "Reference Type is required",
    "professionalReferences-startmonth.less.than.endmonth": "Start month should be less than end month.",
    "professionalReferences-valid.phone.number": "Please enter valid phone number",
    "professionalReferences-valid.email": "Please enter a valid email.",
    "professionalReferences-delete": "Delete this professional reference?",

    // privacy and consent
    "consent_details" : "Consent details",
    "consent_status" : "Status",
    "consent_date" : "Consent Date",
    "consent_expiry_date": "Expiry date",
    "consent_policy_version" : "Policy version",
    "consent_renew" : "Renew consent",
    "consent_renewed" : "Renewed",
    "consent_withdraw" : "Withdraw consent",
    "privacy_consent_header" : "Privacy & consent management",
    "privacy_consent_subheader" : "Manage how your personal data is stored and used for recruitment purposes.",
    "privacy_consent_active_banner_title" : "Your consent is active",
    "privacy_consent_active_banner_text" : "You are currently opted in for recruitment. Your consent expires on {consentExpiray}. You can renew or withdraw at any time.",
    "privacy_consent_renewed_successfull_title" : "Consent renewed successfully",
    "privacy_consent_renewed_successfull_text" : "Your consent is active until {consentExpiray}. No further action is needed.",
    "privacy_consent_grace_banner_title" : "Your consent has expired - grace period active.",
    "privacy_consent_grace_banner_text" : "Your consent expired on {consentExpiry}. You have until {graceEndDate} to renew. After that, your profile will be automatically marked for deletion",
    "privacy_consent_withdrawn_banner_title" : "Consent withdrawn",
    "privacy_consent_withdrawn_banner_text" : "Your consent expired on {consentExpiry}. You have until {graceEndDate} to renew. After that, your profile will be automatically marked for deletion",
    "withdraw_popup_consent_title" : "Are you sure you want to withdraw consent?",
    "withdraw_popup_consent_Content": '<p>You will no longer be considered for further opportunities</p><p>Recruiters will no longer be able to contact you</p><p>Your profile will enter the data deletion process</p>',
    "withdraw_popup_box_content" : "This may result in permanent removal of your profile and personal data",
    "withdraw_cancel_button" : 'Cancel',
    
    //data privacy
    "dataprivacy-remove-data": "Remove My Account and Data",
    "dataprivacy-remove-data-btn": "Remove Data",
    "dataprivacy-remove-data-text" : "Your WorkLLama account and all related data will be deleted effective immediately.",
    // "dataprivacy-remove-data-text": "{companyName} will remove all your personal information effective immediately and you will no longer be contacted for job opportunities",
    "dataprivacy-terms-of-service": "Terms of Service",
    "dataprivacy-terms-of-service-text": "Read more about the terms that govern the use of the {companyName} website operated by WorkLLama"
    , "dataprivacy-privacy-policy": "Privacy Policy",
    "dataprivacy-privacy-policy-text": "Read more about how {companyName} collects and processes your personal information",


    // New translation labels created V2
    "signup.form.firstname": "First Name*",
    "signup.form.lastname": "Last Name*",
    "signup.form.email": "Email*",
    "signup.form.password": "Password*",
    "signup.form.mobile": "Phone Number*",
    "signup.form.referralUrl": "Have a Referral Code (Optional)",
    "signup.form.receiveWhatsappNotification": "Yes, I would like to receive important information and updates over {WhatsappIcon}",

    //SideMenu
    "sidemenu.viewprofile": "View/Update Profile",
    "sidemenu.profilestrength": "Profile Strength",
    "sidemenu.home": "Home",
    "sidemenu.find_jobs": "Find Jobs",
    "sidemenu.my_jobs": "My Jobs",
    "sidemenu.saved_jobs": "Saved Jobs",
    "sidemenu.job_alerts": "Job Alerts",
    "sidemenu.survey": "Survey",
    "sidemenu.forum": "Forum",
    "sidemenu.my_referrals": "My Referrals/Promote {ApplicationName}",
    "sidemenu.refer_a_friend": "Refer a Friend",
    "sidemenu.help": "Help",
    "sidemenu.inbox": "Inbox",
    "sidemenu.timesheets": "Timesheets",
    "sidemenu.logout": "Logout",

    "home.welcome.greeting": "Welcome {greetingName}!",
    "home.welcome.message": "What would you like to do?",
    "home.cards.find_jobs.displayName": "Find Jobs",
    "home.cards.notifications.displayName": "Notifications",
    "home.cards.inbox.displayName": "Chat",
    "home.cards.refer_a_friend.displayName": "Refer a Friend",
    "home.cards.my_jobs.displayName": "My Jobs",
    "home.cards.job_alerts.displayName": "Job Alerts",
    "home.cards.find_businesses.displayName": "Find Businesses",
    "home.cards.timesheets.displayName": "Timesheets",
    "onboarding-complete-document-text": "Complete the required documentation to move forward with your employment",
    "--onboarding-complete-document-open": "Open",
    "onboardingheader-leave-onboarding-text": "Are you sure you want to leave onboarding process?",


    "community-forum.feed_text": "Feed",
    "community-forum.see_all_link": "See All",
    "community-forum.see_all_button": "See All Posts",
    "community-forum.no_post_message": "No posts to show",

    "forum-placeholder.coming-soon.text": "Coming Soon!",
    "forum-placeholder.coming-soon.header": "{companyName} Community Forum",
    "forum-placeholder.coming-soon.message": "Your dedicated community to share and engage with fellow community members",
    "app.banner.text": "Earn rewards by sharing the app with your friends!",

    "profile-accordion.personal_info": "Personal Info",
    "profile-accordion.protected_information": "Protected Information",
    "profile-accordion.social_profiles": "Social Profiles",
    "profile-accordion.work_experience": "Work Experience",
    "profile-accordion.passport": "Passport",
    "profile-accordion.licence": "Licence(s)",
    "profile-accordion.skills_and_speciality": "Skills/Speciality(s)",
    "profile-accordion.additional_documents": "Additional Document(s)",
    "profile-accordion.my_documents": "My Documents",
    "profile-accordion.resume": "Resume/CV",
    "profile-accordion.language": "Language(s)",
    "profile-accordion.education_history": "Education History",
    "profile-accordion.work_preference": "Work Preference",
    "profile-accordion.professional_reference": "Professional References",
    "profile-accordion.notification_preference": "Notification Preference",
    "profile-accordion.change_password": "Change Password",
    "profile-accordion.discipline_specialties": "Discipline & Specialities",
    "profile-accordion.data_and_privacy_settings": "Data, Privacy and Account Settings",

    "profile-wizard-button.buttonLabel": "Profile Wizard",
    "profile-wizard-button.requiredStepHeader": "Well done! | You are 1 step away! | You are {count} steps away!",
    "profile-wizard-button.requiredStepIncompleteMessage": "Strengthen your candidacy by completing your profile today!",
    "profile-wizard-button.requiredStepCompletedMessage": "You’ve enhanced your candidacy by completing the required steps in your profile. Check out some of the other sections below!",
    "profile-wizard-button.estimateTime.uom": "min",
    "profile-wizard-button.estimateTime.label": "Estimated Time Of Completion",

    // work experience
    "workExperience.no.experience": "No work experience yet",
    "workExperience.company.assignment": "Your {companyName} assignments will be displayed here",
    "workExperience.add.work-experience": "Please add a work experience to your profile",
    "workExperience.add.work-experience-btn": "Add Work Experience",
    "workExperience.select-company-placeholder": "Enter 3 Characters to select a Company",
    "placeholder-enter-job-location": "Enter your Job Location",
    "placeholder-enter-job-title": "Enter your Job Title",
    "placeholder-supervisor-name": "Enter your Supervisor Name",
    "workexperience-no-job-istory": "No jobs history yet",


    // refer a friend
    "refer-a-friend-placeholder": "OPTIONAL: To help the recruiting team start the conversation, add a quick note about your friend’s background, such as their profession and/or previous job title. Feel free to upload a relevant document, like your friend's resume, below.",
    "refer-a-friend-phoneNumber": "Phone Number",
    "refer-a-friend-select-doc": "Select Document",
    "refer-a-friend-select-current-recruiter": "Select the recruiter you currently work with, otherwise leave blank and submit your referral",


    "jobdetails.apply-now-text": "Apply now",
    "jobdetails-job-saved-text": "Job Saved",
    "jobdetails-job-number-text": "Job Number",
    "jobdetails-discipline-text": "Discipline",
    "jobdetails-save-job": "Save Job",


    "inbox.message.emptyList": "No Responses to Display. Please check later!",
    "inbox.message.invalidEmailBody": "Please enter a valid message with at least three characters.",
    "inbox.modal.viewAttachmentHeader": "View Attachment",
    "inbox.label.emailBody": "Type your message",
    "inbox.button.send": "Send",
    "inbox.candidte.blocked.status.message" : "We're having a technical issue that might be affecting our communication system. Sorry for the inconvenience.",
    "survey-no-survey-yet-title": "No Surveys yet",
    "survey-no-survey-yet-message": "Occasionally we'll send you surveys to get your feedback and insight on things. Your responses will be stored here.",
    "survey-responded-text": "Survey Responded",
    "survey-response-pending-text": "RESPONSE PENDING",
    "survey-invalid-email": "* Invalid Email",
    "survey-invalid-ph-number": "* Invalid Phone Number",
    "survey-allowed-characters": "* Allowed only {AllowedChars} characters",
    "survey-question-min-length": "* Min {minLength} characters",
    "survey-end-text": "You have reached the end of this survey.",
    "survey-end-action-text": "Please click <span class='primary-color'>Back</span> to update your responses or <span class='primary-color'>Submit</span> to end survey.</span>",

    "global.ok.text": "OK",
    "global.open.text": "Open",
    "global.cancel-text": "Cancel",
    "global-update-text": "Update",
    "global-save-text": "Save",
    "global-submit-text": "Submit",
    "global-back-text": "Back",
    "global-next-text": "Next",
    "global-save-exit-text": "Save & Exit",
    "global-skip-text": "Skip",



    // New translation labels created V3
    "findjobs.text.applicationSubmitted": "APPLICATION SUBMITTED",
    "findjobs.text.noJobsFound": "No Jobs found for the selected criteria",
    "findjobs.text.readMore": "Read more",
    "findjobs.text.viewLess": "View Less",
    "myjobs.text.position": "{pos} Position | {pos} positions",
    "myjobs.text.jobOffered": "JOB OFFERED",
    "myjobs.text.hired": "HIRED",
    "myjobs.text.viewDetails": "View Details",
    "myjobs.text.viewLess": "View Less",
    "emailConfirmation.text": "Email Address Confirmation",
    "phoneNumberConfirmation.text": "Phone Number Confirmation",
    "addEducationHistory.text": "+ Add Education History",
    "errorMessage.text": "Error Message!",
    "numberOfShifts.text": "1 Shift Weekly {hrs} Hrs | {num} Shifts Weekly {hrs}",
    "savedJobs.text": "Saved Jobs",
    "add-edit-text": "Add/Edit Details",
    "licence-country-text": "Licence Country",
    "aircraft-airframetype.text": "Aircraft/Airframe Type",
    "licence-authority.text": "Licence Authority",
    "similar-jobs.text": "Similar Jobs",
    "no-similar-jobs-found.text": "No similar jobs found",
    "similar-jobs-email.text": "Enter your email to receive alerts when we find similar jobs.",
    "email-frequency-text": "Email Frequency",
    "email-frequency-daily": "Daily",
    "email-frequency-weekly": "Weekly",
    "email-frequency-monthly": "Monthly",
    "create-alert-text": "Create Alert",
    "field-is-mandatory-text": "* - Field is mandatory",
    "required-field-missing-text": "Required field missing",
    "upload-resume-text": "+ Upload Resume/CV",
    "account-lock-text1": "For your security, this account has been locked.",
    "account-lock-text2": "Unlock by resetting your password.",
    "profile-pic-upload-success-message": "Profile Picture Uploaded Successfully!",
    "profile-pic-unsupported-error-message": "Error {fileNameFormat} is an unsupported file format. Following file formats are allowed: .png, .jpeg",
    "unable-to-delete-skill-err-msg": "Unable to Delete Skill",
    "document-name-err-msg": "Document Name is required",
    "document-type-err-msg": "Document Type is required",
    "select-file-err-msg": "Select a file!",
    "document-size-err-msg": "Document size must be within {num} MB",
    "document-expire-err-msg": "Expiry date must be greater than Effective date!",
    "document-start-err-msg": "Enter Effective date!",
    "document-upload-err-msg": "Error in uploading document",
    "document-delete-err-msg": "Error in document deletion",
    "password-min-requirment-text": "Password does not satisfy the minimum requirement!",
    "password-does-not-match-text": "Password does not match!",
    "ph-number-change-err-msg": "Error while changing phone number",
    "quicksignup-details-same-referrer": "Referee's email address or phone number is same as the Referrer",
    "skill-deleted-success-msg": "Skill Deleted Successfully",
    "document-saved-success-msg": "Data Saved Successfully",
    "document-delete-success-msg": "Successfully deleted document",
    "resent-otp-success-msg": "Resent OTP Successfully!",
    "new-verification-code-sent": "New verification code sent",
    "terms-and-condition-text": "Terms & Conditions",
    "agree-and-continue-text": "Agree & Continue",
    "languages-text": "Languages:",
    "edit-protected-info-text": "Edit Protected Information",
    "dob-text": "Date Of Birth(DOB)",
    "edit-social-profiles-text": "edit social profiles",
    "change-ph-number-text": "Change Phone Number",
    "enter-ph-number-text": "Enter the phone number that you would like to change",
    "update-ph-text1": "We will send an activation link to your registered email id.",
    "update-ph-text2": "Please keep in mind. The activation link can take up to 5 minutes to send.",
    "desired-work-location-text": "Desired Work Location(s)",
    "desired-pay-text": "Desired Pay",
    "current-pay-text": "Current Pay (Optional)",
    "employment-preference-text": "Employment Preference",
    "shift-preference-text": "Shift Preference",
    "questionnaire.text": "Questionnaire",
    "questionnaire-save-questionnaire-text": "Save Questionnaire",
    "upload-from-computer-text": "Upload from computer",
    "save-supporting-info": "Save Supporting Info",
    "license-state-text": "License State",
    "license-number-text": "License Number",
    "document-expired-text": "Document expired",
    "document-expires-soon-text": "Document expires soon",
    "global.clear.text": "Clear",
    "global.phone.number.text": "Phone number*",
    "searchbox-descipline-text": "Discipline",
    "searchbox-alert-saved-text": "Alert saved",
    "searchbox-showing-jobs-text": "Showing jobs",
    "searchbox-in-and-around-text": "in and around",
    "searchbox-date-added-text": "Date Added",
    "searchbox-pay-text": "Pay",
    "resume-details-from-drop-box-text": "from dropbox",
    "resume-details-file--format-allowed-text": "File format allowed are {fileFormat}",
    "resume-details-default-text": "Default",
    "resume-details-add-new-resume-text": "Add new Resume/CV",
    "resume-details-renaming-resume-text": "Renaming Resume",
    "resume-details-rename-btn": "Rename",
    "referrals-program-start-date-text": "Program Start Date",
    "referrals-program-end-date-text": "Program End Date",
    "referrals-program-description-text": "Program Description",
    "referrals-on-assignment-text": "On Assignment",
    "referrals-off-assignment-text": "Off Assignment",
    "referrals-level-texxt": "Level",
    "referrals-fixed-incentive-text": "Fixed Incentive",
    "referrals-incentive-text": "Incentive",
    "referrals-variable-incentive-text": "Variable (Var) Incentive",
    "refermodal-inv-your-friends-text": "Invite your friends",
    "refermodal-import-gmail-contacts-text": "Import Gmail Contacts",
    "refermodal-emailsaperate-with-comma-text": "Email Separate with comma",
    "refermodal-signup-or-provide-contact-text": "Please Sign up or Provide your contact information below so we may contact you for your Referral bonus pay",
    "refermodal-continue-with-text": "Continue with",
    "refermodal-privacy-policy-on-continue-text": "By clicking continue you agree to the Terms of Service and Privacy Policy",
    "refer-a-friend-select-recruiter-text": "Select the recruiter you currently work with, otherwise leave blank and submit your referral",
    "myreferrals-referrals-text": "referrals",
    "myreferrals-refer-and-get-paid-text": "Refer a friend and get paid.",
    "my-profile-details-total-flight-hrs-text": "Total flight hours",
    "my-profile-details-role-text": "Role",
    "my-profile-details-change-number-text": "Change Number",
    "my-profile-details-confirm-password-text": "Confirm Password",
    "my-profile-details-change-email-text": "Change Email",
    "my-profile-details-address1-text": "Address 1",
    "my-profile-details-address2-text": "Address 2",
    "my-profile-details-country-text": "Country",
    "my-profile-details-activation-email-text": "Activation Email Sent",
    "my-profile-details-did-not-get-email-text": "Didn't get the email?",
    "my-profile-details-resend-activation-link-btn": "Resend activation link to my email",
    "jobstatus-applied-text": "Applied",
    "jobstatus-hired-text": "Hired",
    "jobstatus-offered-text": "Offered",
    "jobstatus-you-have-not-applied-for-any-jobs": "You haven't applied for any jobs.",
    "job-status-no-jobs-offer": "No job offers as of yet.",
    "job-status-not-yet-hired-text": "You have yet to hired for any jobs.",
    "jobpager-job-per-page-text": "Jobs per page:",
    "jobpager-create-job-alert-text": "Create Job Alert",
    "jobpager-alert-name-text": "Alert Name",
    "jobpager-alert-full-name": "Full Name",
    "jobpager-receive-daily-email-text": "I want to receive daily e-mail updates pertaining to this alert",
    "jobpager-search-citeria-text": "Search Criteria",
    "jobpager-email-text": "E-mail",
    "jobdetails.view-less-text": "View Less",
    "jobdetails-job-save-text": "Save Job",
    "jobdetails-job-description-text": "JOB DESCRIPTION",
    "jobdetails-job-skills-text": "JOB SKILLS",
    "jobdetails-refer-text": "Refer",
    "passport-no-passport-yet": "No passport yet!",
    "passport-add-passport-to-profile": "Add your passport(s) to your profile",
    "passport-add-passport-text": "Add passport(s)",
    "passport-passport-number": "Passport Number",
    "skillcard-experience-text": "Experience",
    "skillcard-primary-text": "Primary",
    "skillcard-make-it-primart-text": "Make it primary",
    "skillcard-skills-checklist-text": "Skills Checklist",
    "skillcard-pending-text": "Pending",
    "skillcard-completed-text": "Completed",

    "skillchecklist-profiency-text": "Proficiency",
    "skillchecklist-frequency-text": "Frequency",
    "skillchecklist-certify-text": "Certify",
    "skillchecklist-certification-text": "Certification",
    "skillchecklist-applicant-signature-text": "Applicant Signature*",
    "custom-field-resume-required-text": "Resume is the only requirement to apply for a position",
    "forum-title-text": "Forum",
    "forum-welcom-text": "Welcome to {companyName} Forum",
    "forum-share-your-thoughts-text": "You can share your thoughts with your friends here",
    "forum-report-comment-text": "This comment has been reported. Please make changes to the comment",
    "forum-report-post-text": "This post has ben reported..Please make changes to the post",
    "forum-report-reason-text": "Select a reason for reporting this post",
    "forum-post-writer": "Write a post..",
    "forum-create-post-text": "Create a post",
    "forum-categories-text": "Categories",
    "forum.all.text": "All",
    "forum-filter-by-text": "Filtered by",
    "forum-nobody-liked-text": "Nobody liked this post yet",
    "forum-select-catagory": "Select a category",
    "forum-post-btn": "POST",
    "forum.edit.btn": "Edit",
    "forum.delete.btn": "Delete",
    "forum-no-result": "No Results Found Try with different text",
    "jobapplication-success-message": "Your Application is successfully submitted.",
    "profile-missing-key-skills-text": "Your profile is missing key skills found in the job listing!",
    "candidate-with-relevant-skills-text": "Candidates with three or more relevant skills are <strong style='color: #313131;'>4x</strong> more likely to receive an interview. Add them to your profile today!",
    "browse-more-jobs-text": "BROWSE MORE JOBS",
    "header-refer-a-friend": "Refer a Friend",
    "header-sign-up": "Sign up",
    "header-saved-jobs": "Saved Jobs",
    "header-find-jobs": "Find Jobs",
    "forgot-password-resert-password-text": "Don't worry we'll help you reset your password",
    "companyprofile-no-desc-found-text": "No description found",
    "change-password-reset-password-text": "Reset Password",
    "change-password-temp-password-text": "Temporary Password:",
    "change-password-new-password-text": "New Password:",
    "chang-password-confirm-password-text": "Confirm Password",
    "change-password-text": "CHANGE PASSWORD",
    "broadcast-message-from-admin-text": "Message from Admin",
    "banner-sign-up": "SIGN UP",
    "banner-sign-in": "SIGN IN",
    "banner-find-jobs": "FIND JOBS",
    "gsu-missing-mandatory-steps": "Missing Mandatory Sections",
    "gsu-complete-below-mandatory-sections": "Please complete the below mandatory sections to submit your application.",
    "gsu-complete-missing-sections": "Complete Missing Sections",
    "professional-referrence-contact": "I understand that my reference may be contacted to verify my skills, expereience, education and work history.",
    "add-prefessional-reference-text": "+ Add Professional References",
    "timesheet-add-time-sheet-text": "add timesheet",
    "timesheet-worked-hours-text": "Worked hours",
    "timesheet-time-off hours": "Time-off hours",
    "timesheet-cient-job-info-text": "Client & Job Information",
    "timesheet-client-name-text": "Client Name*",
    "timesheet-job-name-text": "Job Name*",
    "timesheeet-job-location": "Job Location*",
    "time-sheet-project-code-text": "Project Code",
    "timesheet-details-text": "Timesheet Details",
    "timesheet-start-date": "Start Date",
    "timesheet-end-date": "End Date",
    "timesheet-worked-hours": "Worked Hours",
    "timesheet-time-off-hours": "Time-off Hours",
    "timesheet-apply-all-day": "Apply to All Days",
    "timesheet-totdal-text": "Total: {totalHrs}",
    "timesheet-comments-text": "Comments",
    "timesheet-save-for-later": "Save For Later",
    "timesheet-date-range-text": "Date Range",
    "target-recruit-header": "Are you sure you want to leave Timesheets page?",
    "app-referral-msg": "Browse jobs, manage & track your applications, refer your friends!",
    "search-box-range-text": "Within",
    "search-box-all-filters": "All Filters",
    "search-box-showing-jobs": "Showing jobs",
    "search-box-keywords-text": "for",
    "search-box-search-text": "in and around",
    "search-box-alert-saved": "Alert saved",
    "search-box-saved-as-alert": "SAVE AS ALERT",
    "search-box-share-search": "Share this search",
    "search-box-copy-link": "copy link",
    "search-box-link-copied": "link copied",
    "search-box-get-alerts": "Get alerts",
    "sign-up-footer-text": "Have an account? Login",
    "retreive-old-email-ph-number-exists": "Mobile number already exists",
    "retreive-old-email-text": "The mobile number you entered is associated with another Email ID. Do you want to retrieve the Email ID via SMS to complete sign up?",
    "retreived-email-verification-text": "Information Sent",
    "retreived-email-sign-up-pref": "Choose your preference",
    "retreived-email-sign-up-text": "Use Retrieved Email ID to complete Sign up",
    "retreived-email-use-socials-text": "Use Social Media Account to complete Sign up",
    "placeholder.full-name": "Full Name",
    "placeholder-email": "Email",
    "placeholder-please-select-values": "please select values",
    "placeholder-start-date": "Start Date",
    "placeholder-end-date": "End Date",
    "placeholder-enter-state": "Enter state",
    "placeholder-enter-number": "Enter number",
    "placeholder-role": "Role",
    "placeholder-city-state": "City, State",
    "placeholder-company-search": "Enter 3 Characters to select a Company",
    "placeholder-email-ph-number": "Email or Mobile number",
    "placeholder.start-typing": "Start typing...",
    "placeholder.Address-one": "Address 1",
    "placeholder.Address-two": "Address 2",
    "placeholder.country": "Country",
    "placeholder.city": "City",
    "placeholder-zip-code": "Postal Code",
    "placeholder.password": "Password",
    "placeholder-confirm-password": "Confirm Password*",
    "placeholder-min-sal": "Min Salary",
    "placeholder-max-sal": "Max Salary",
    "placeholder-preferred-name": "Preferred name",
    "placeholder-new-email": "New Email",
    "placeholder-enter-flight-hrs": "Enter total flight hours",
    "placeholder-new-address": "New Address",
    "placeholder-resume-name": "Resume Name",
    "placeholder-drop-resume": "Drop Resume here...",
    "placeholder-choose-file": "Choose a file...",
    "placeholder-job-title": "Job Title/ Description or Company",

    "placeholder-timesheet-search": "Search by Client Name, Job Name or Location",
    "placeholder-timesheet-details": "Please add any relevant details prior to submitting your timesheet.",
    "placeholder-timesheet-cleint-name": "Select a Client Name",
    "placeholder-timesheet-jobname": "Select a Job Name",
    "placeholder-timesheet-job-location": "Select a Job Location",
    "placeholder-project-code": "Enter a Project Code",
    "placeholder-select-values": "please select values",
    "placeholder-gross-pay": "Gross Pay",
    "placeholder-current-pay": "Current Pay",
    "placeholder-available-date": "Availablity Date",
    "placeholder-emp-prefrence": "Employment preference",
    "placeholder-shift-preference": "Shift preference",
    "placeholder-search-Discipline": "Search Discipline",
    "placeholder-languages-you-speak": "Search for languages you speak",
    "placeholder-referral-code": "Have a Referral Code (Optional)",
    "placeholder-country-passport": "Country of Passport*",
    "placeholder-latest-rank": "Latest Rank*",
    "placeholder-current-job-title": "Current Job Title",
    "placeholder-company-not-inl-list": "This company is not in the list. Do you want to add?",
    "placeholder-current-comapny": "Latest/Current Company*",
    "placeholder-type-of-licence": "Type of Licence*",
    "placeholder-licence-authority": "Licence Authority*",
    "placeholder-country-of-licence": "Country of Licence*",
    "sidemenu.findjobs": "Find Jobs",
    "sidemenu.myjobs": "My Jobs",
    "sidemenu.jobalerts": "Job Alerts",
    "sidemenu.myreferrals": "My Referrals",

    "education-history-location": "Location*",
    "education-history-major": "Field of Study (Major)",
    "data-privacy-remove-data": "Remove My Data {companyName} will remove all your personal information effective immediately and you will no longer be contacted for job opportunities",
    "data-privacy-remove-btn": "Remove Data",
    "data-privacy-terms": "Read more about the terms that govern the use of { companyName } and any other { companyName } website operated by WorkLLama",
    "data-privacy-policy": "Read more about how { companyName } collects and processes your personal information"
    ,
    //job alerts
    "jobalert.alert.me": "Alert me",
    "jobalert.select.all": "Select all",
    "jobalert.resume.alert": "Resume alerts",
    "jobalert.pause.alert": "Pause alerts",
    "jobalert.delete.alert": "Delete alerts",
    "jobalert.selected.msg": "All {CheckedId} job alerts on this page are selected.",
    "jobalert.select.all.alert": "Select all {alertsCount} job alerts in all pages.",
    "jobalert.all.selected": "All {alertsCount} job alerts  in all pages are selected.",
    "jobalert.clear.selection": "Clear selection",
    "jobalert.radius": "Radius:",
    "jobalert.within.miles": "Within {milees} Miles",
    "jobalert.inactive.alert": "Inactive Alert",
    "jobalert.check.email": "Check your email to activate",
    "jobalert.alert.paused": "Alert paused",
    "jobalert.daily": "Daily",
    "jobalert.weekly": "Weekly",
    "jobalert.delete": "Delete alert",
    "jobalert.resend.activation.email": "Resend activation email",
    "jobalert.manage.alerts": "Manage alert",
    "jobalert.pause": "Pause alert",
    "jobalert.resume": "Resume alert",
    "jobalert.via": "Via",
    "jobalert.location": "Location:",

    "find-jobs-no-application": "No applications yet",

    // my jobs
    "myjobs.interview": "Interview",
    "myjobs.application.submitted": "APPLICATION SUBMITTED",
    "myjobs.application.applied" : "Applied",
    "myjobs.job.offered": "JOB OFFERED",
    "myjobs.accepted": "ACCEPTED",
    "myjobs.refused": "JOB REFUSED",
    "myjobs.reson": "Reason category",
    "myjobs.job.stand.by": "JOB STANDBY",
    "myjobs.job.revoked": "JOB REVOKED",
    "myjobs.view.offer": "View offer",
    "myjobs.accept": "ACCEPT",
    "myjobs.reason.catagory": "Reason category",
    "myjobs.select": "Select",
    "myjobs.cancel": "Cancel",
    "myjobs.proceed": "proceed",
    "myjobs.reject": "Reject",
    "myjobs.Terminated": "Terminated",
    "myjobs.Declined": "Declined",
    "myjobs.hired": "HIRED",
    "myjobs.applied.jobs.shown.here": "Any jobs that you apply to will be shown here.",
    "myjobs.nothing.yet": "Nothing yet",
    "myjobs.track.offer.text": "When your application results in a job offer, you can track it here.",
    "myjobs.not.yet": "Not yet",
    "myjobs.once.you.get.placed": "But don't give up hope! Once you get placed, your assignments will show up here.",
    "myjobs.no.jobs.saved.yet": "No jobs saved yet",
    "myjobs.jobs.saved.during.job.search": "Jobs you save during a job search will be shown here. Click the ribbon on any job to save or remove it from this list.",

    // saved jobs
    "saved.jobs.pages.text": "Page <b>{resultCount}</b> of {totalPageCount}",


    "Facility.radius.value": "Within {range} Miles",
    "JobPosting.candidatePlacementType": "Job Type",
    "distance.units.miles": "Miles",
    "distance.units.kilometers": "Kilometers",
    "Clear": "Clear",
    "search-box-button-search": "Search",
    "myreferrals.offered": "Offered",
    "application-link.updateprofile": "Update Profile",
    "findjobs.button.offerWithdrawn": "OFFER WITHDRAWN",
    "jobapply.resume.select": "SELECT YOUR RESUME/CV",
    "skills.label.addsupportingdcouments": "Add supporting documents",
    "refer-a-friend-browse-text": "Browse",

    "forum-title-placeholder": "Add a title",
    "forum-post-placeholder": "Write your post",
    "forum-search-placeholder": "Search by post title or content",
    "myreferrals.search-placeholder": "Search here by Job name, ID and location",
    "myreferrals.total-incentive-text": "Total Incentive",
    "referrals-fixed-text": "Fixed:",
    "referrals-variable-text": "Variable",
    "global-or-text": "or",

    "menu.top.joincommunity": "Join Talent Community",
    "menu.top.browsejobs": "Current Openings",
    "menu.top.lifeAtLabel": "Life at",


    "license-state-text-if-applicable": "License State (If applicable)",
    "license-number-text-if-applicable": "License Number (If applicable)",
    "global.continue.text": "Continue",

    "jobapplicationsuccess.thankyou": "Thank you!",
    "jobapplicationsuccess.message": "Your application has been submitted. Interested in creating an <br /> account? Simply enter a password using the link below.",
    "jobapplicationsuccess.complete-account-button": "Complete account",

    "placeholder-file-browse": "Browse",
    "global.countrycode.text": "Country code",
    "userjobhistory.label.current": "Current",
    "userjobhistory.label.present": "Present",
    "global.label.yes": "Yes",
    "global.label.no": "No",

    "skillcard-enter-year-of-experience-text": "Enter years of experience",
    "skillcard-search-skill-placeholder": "Search Skills/Specialties",

    "global-save-continue-text": "Save & Continue",
    "global-profilestrength-text": "Profile Strength",
    "guidedsignup.header.welcome": "Welcome, {greetingName}!",
    "gsu-select-your-role-header": "Select your role",
    "gsu-select-your-role-subheader": "We’ll recommend jobs that are a great fit for you",
    "gsu-navigator-page-of-text": "of",
    "enter-location-info-text": "Enter Location Information",
    "workPreference-payuom-per-label": "Per",
    "educationHistory-from-date-label": "From",
    "educationHistory-to-date-label": "To (Actual or Expected)",
    "educationHistory-out-of-label": "Out of",

    "file-upload-error-message": "File size cannot exceed {num} mb",

    "professionalReferences-required-step-info": "You need to have at least {entries} professional references",
    "professionalReferences-label-salutation": "Salutation*",
    "professionalReferences-please-select": "Please Select",
    "professionalReferences-location": "Location*",
    "professionalReferences-location-placeholder": "Please type and select city",
    "professionalReferences-worked-together": "Worked Together Details",
    "professionalReferences-reference-type": "Reference Type*",
    "professionalReferences-label-former": "Former",
    "professionalReferences-label-current": "Current",
    "professionalReferences-label-from-date": "From*",
    "professionalReferences-label-to-date": "To*",
    "professionalReferences-label-relationship": "Relationship*",
    "professionalReferences-label-company": "Company*",
    "professionalReferences-label-worked-together": "Worked Together",


    "placeholder-drop-file": "Drop file here...",

    "placeholder-select-category": "Select categories",
    "placeholder-job-type": "Job Type",
    "placeholder-industry": "Industry",
    "placeholder-skills-speciality": "Job Skill / Specialty",
    "placeholder-shift-type": "Shift type",
    "placeholder-remote-jobs": "Remote Jobs",
    "placeholder-job-tags": "Job Tags",
    "placeholder-setting-type": "Setting Type",
    "placeholder-type-msg": "Type a message",

    "placeholder-enter-loc-info": "Enter Location Information",
    "placeholder-years-of-exp": "Enter years of experience",
    "placeholder-leave-thoughts": "Leave your thoughts here...",
    "placeholder-add-title": "Add a title",


    "placeholder-search-title": "Search by post title or content",
    "placeholder-search-licences": "Search Licences",
    "placeholder-passport-num": "Passport Number",
    "placeholder-reference-first-name": "Reference First Name*",
    "placeholder-reference-last-name": "Reference Last Name*",
    "placeholder-reference-email": "Reference Email*",
    "placeholder-type-select-city": "Please type and select city",
    "placeholder-reference-job-title": "Reference Job Title*",
    "placeholder-my-jobb-title": "My Job Title*",
    "placeholder-enter-reference-name": "Enter reference name",
    "placeholder-reference-ph": "Reference Phone*",
    "placeholder-reference-ph-placeholder":"Reference Phone",
    "placeholder-community-partners": "Select the Community Partner(s) you are affiliated with",
    "placeholder-company-partners": "Select the Community Partner(s) you are affiliated with",
    "placeholder-type-text": "Type your text here...",
    "placeholder-reference-name": "Reference name*",
    "jobalert-delete-modal-title": "Delete alert?",
    "jobalert-delete-modal-message": "Are you sure you want to delete this alert?",
    "jobalert-delete-all-modal-title": "Delete alerts?",
    "jobalert-delete-all-modal-message": "Delete the selected alerts? Be careful, this action cannot be undone.",
    "jobalert-delete-modal-success-message": "Alert(s) successfully deleted.",
    "jobalert-pause-all-modal-title": "Pause alerts?",
    "jobalert-pause-all-modal-message": "Don’t worry, your saved alerts will still be here. We’ll pause these alerts for now until you turn them back on.",
    "jobalert-pause-modal-title": "Pause alert?",
    "jobalert-pause-modal-message": "Don't worry, your alert will still be here. We'll pause it for now until you turn it back on.",
    "jobalert-pause-modal-success-message": "Alert(s) paused successfully",
    "jobalert-resend-email-modal-title": "Resend confirmation email?",
    "jobalert-resend-email-modal-message": "A new email with activation link will be sent to {email}.",
    "jobalert-resume-all-modal-title": "Resume paused alerts?",
    "jobalert-resume-all-modal-message": "Selected alerts will be resumed. Feel free to pause it again at any time.",
    "jobalert-resume-modal-title": "Resume alert?",
    "jobalert-please-select-atleast-one-msg": "Please select at least one job alert",
    "jobalert-resume-modal-message": "Your alert will be resumed. Feel free to pause it again at any time.",
    "jobalert-resume-modal-success-message": "Alert(s) Resumed Successfully",
    "jobalert-activation-modal-success-message": "Job alert activation email sent successfully, please check your email.",
    "jobalert.manage.getnotified.msg": "Get notified of the relevant jobs that fit your search and filters",
    "jobalert-created-success-message": "Job Alert created successfully.",
    "jobalert-created-anon-success-message": "Job Alert created successfully. Please check the email address provided to validate your subscription.",

    "global.confirm-text": "Confirm",

    "DataPrivacySettings_ConfirmRemoval": "Confirm removal of data?",
    "DataPrivacySettings_RemovalData": "Removal of data will delete the data that was relevant to you including information that you have provided and interacted with.<br/><br/> You will not be able to restore your data after this action.<br/><br/>Please refer to the <a class='font-weight-bold' href='{termsOfServiceURL}' target='_blank'>Terms of Service</a> and  <a class='font-weight-bold' href='{privacyPolicyURL}' target='_blank'>Privacy Policy</a> for additional information.",

    "LocalJobs_SavedJobs": "Saved Jobs",

    "Jobdetails_LoginPrompt": "Please register or login to continue the application process",
    "Jobdetails_RedirectionPrompt": "We will be redirecting you to a different webpage to continue the application process",

    "JobAlert_JobAlert": "Job Alert",
    "JobPager_Location": "Location",
    "JobPager_Industry": "Industry",

    "UpdatePhoneNumberNew_NewPhoneNumber": "New Phone Number",
    "UpdatePhoneNumberNew_ChangePhoneNumber": "CHANGE PHONE NUMBER",

    "MyProfileDetailsNew_ActivationEmailSent": "Activation Email Sent",
    "MyProfileDetailsNew_OK": "OK",

    "UserProfile_PasswordRequirements": "Password must contain minimum 8 characters and at least 1 uppercase letter and at least 1 number",
    "UserProfile_MyProfile": "My Profile",


    "PasswordIndicator_MinimumCharacters": "Minimum {value} characters",
    "PasswordIndicator_AtLeastUppercase": "At least {value} uppercase letter",
    "PasswordIndicator_AtLeastNumber": "At least {value} number",
    "PasswordIndicator_AtLeastSpecialCharacter": "At least {value} allowed special character",


    "NewJobHistoryDetails_DeleteExperience": "Delete work experience?",
    "NewJobHistoryDetails_ConfirmDeleteExperience": "Are you sure you want to delete the work experience?",
    "NewJobHistoryDetails_WorkExperience": "Work Experience",
    "NewJobHistoryDetails_WorkExperienceDeleteSuccessful": "Work Experience Deleted Successfully",
    "NewJobHistoryDetails_DeleteExperienceError": "Work Experience Deletion Error",
    "NewJobHistoryDetails_WorkExperienceUpdateSuccessful": "Work Experience updated successfully",
    "NewJobHistoryDetails_WorkExperienceCreationSuccessful": "Work Experience Creation Successful",
    "NewJobHistoryDetails_WorkExperienceFutereStartDateError": "Start date cannot be in the future!",
    "NewJobHistoryDetails_WorkExperienceEndDateGreaterThanStartDateError": "End date must be greater than start date!",
    "NewJobHistoryDetails_WorkExperienceFutereEndDateError": "End date cannot be in the future!",
    "NewJobHistoryDetails_WorkExperienceUpdateError": "Error Updating Job History. Please ensure all required fields are populated!",


    "please-enter-valid-location-error-text": "Please enter valid location.",

    "EducationHistory_EducationHistory": "Education History",
    "EducationHistory_EnterCity": "Please enter a city",

    "ResumeDetails_UploadResume": "Upload Resume/CV",
    "ResumeDetails_UploadResumeRequired": "Upload Resume/CV*",
    "ResumeDetails_SecurityRisk": "This file contains security risk. Please upload another file.",
    "ResumeDetails_SizeRestriction": "Resume size must be within {maxSize} MB",
    "ResumeDetails_DeleteResume": "Delete Resume",
    "ResumeDetails_DefaultResumeDeleteError": "Cannot delete default resume. Please provide another default and try again!",
    "ResumeDetails_DefaultResume": "Default Resume",
    "ResumeDetails_SetDefaultResume": "Set Default Resume",
    "ResumeDetails_NoResumeInProfile": "No Resume in Profile",


    "License_DeleteLicence": "Delete this licence?",
    "License_LicenceText": "Licence",
    "License_LicenceDeletedSuccessfully": "Licence has been deleted successfully",
    "License_DocumentUpdatedSuccessfully": "Licence document updated successfully",
    "License_DocumentUploadedSuccessfully": "Licence document uploaded successfully",
    "License_FileNameRestriction": "File name should be less than 250 characters",
    "License_EnterExpiryDate": "Please Enter Expiry date!",
    "License_EnterEffectiveDate": "Please Enter Effective date!",
    "License_FileSizeRestriction": "File size must be within {maxSize} MB",

    "JobAlert_MandatoryTitleOrLocationMsg": "Job Title or Location is required!",
    "JobAlert_MandatoryJobAlertNameMsg": "Job Alert Name is required!",
    "JobAlert_MandatoryEmailMsg": "Email is required!",
    "JobAlert_MandatoryFrequencyMsg": "Job Alert Frequency is required!",
    "JobAlert_AnonAlertCreatedSuccessfulyHeader": "Activate your alert",
    "JobAlert_AnonAlertCreatedSuccessfulySubHeader": "Get notified of relevant jobs that fit your search and filters",
    "JobAlert_AnonAlertCreatedSuccessfulyNextSteps": "Next steps",
    "JobAlert_AnonAlertCreatedSuccessfulyBody": "An email has been sent to {email}. Please make sure that you click on the email to activate the alert notifications.",
    "JobAlert_AnonAlertCreatedSuccessfulySubBody": "Your alert named {alertName} has been created successfully.",
    "JobAlert_EnableJobAlertLabel": "Enable job alert",
    "JobAlert_NoFiltersSelected": "No filters are applied",
    "JobAlert_RadiusLabel": "Radius",
    "JobAlert_AlertSavedSuccessfulyMsg": "Alert successfully updated!",
    "JobAlert_AlertDeletedSuccessfulyMsg": "Job Alert Deleted Successfully",
    "JobAlert_CantLoadJobAlertsMsg": "Cannot load Job Alerts",


    "global.jobtitle.text": "Job Title",


    "Wrapper_MandatorySection": "Please fill in this mandatory section, before proceeding",

    "MyJobIntermediateStep_AreYouSure": "Are you sure you want to reject this Interview Round?",
    "MyJobIntermediateStep_ApplicationScreened": "Your application is being screened",
    "MyJobIntermediateStep_ApplicationReviewed": "Your application is being reviewed",
    "MyJobIntermediateStep_SelectedForInterview": "You’ve been selected for an interview",
    "MyJobIntermediateStep_ResponseSaved": "Your Response Saved successfully",
    "MyJobIntermediateStep_WorkflowStepSubmission": "Workflow Step Submission",
    "MyJobIntermediateStep_InterviewSlotSelected": "Interview Slot Selected Successfully",
    "MyJobIntermediateStep_InterviewSlotRejected": "Interview Slot Rejected",

    "MyJobListing_OfferedJobs": "Offered Jobs",
    "MyJobListing_JobApplication": "Job Application",
    "MyJobListing_JobApplication_LoginRequiredMessage": "Please login to apply for this job as it involves additional steps to be completed for job application.",
    "job-apply-text": "Job Apply",
    "error-getting-supporting-documents": "Error fetching Supporting Documents",

    "SkillsDetails_DeleteOptionNotAvailable": "Delete option is not available",
    "SkillsDetails_VerifiedDocumentCannotBeDeleted": "Verified document cannot be deleted",
    "SkillsDetails_EditOptionNotAvailable": "Edit option is not available",
    "SkillsDetails_VerifiedDocumentCannotBeEdited": "Verified document cannot be edited",

    "SkillsDetails_SuccessfullyUploaded": "Successfully uploaded",
    "SkillsDetails_CancelUpload": "Upload cancel",
    "SkillsDetails_DocumentUpload": "Document Upload",
    "SkillsDetails_EnterLicenseNumber": "Please Enter License Number!",
    "SkillsDetails_EnterLicenseState": "Please Enter License State!",

    "this.field.required": "This field is required",
    "something.went.wrong": "Something went wrong",
    "please.try.again": "Please try again!",
    "education.history.updated": "Education History successfully updated!",
    "gpa.less.than.max": "GPA value should be less than maximium value",
    "value.not.more.than.hundred": "Value should not be more than 100",
    "start.date.less.than.end.date": "Start date should be less than end date",
    "delete.education.history": "Delete Education History ?",
    "are.you.sure.you.want.to.delete": "Are you sure you want to delete the education history?",
    "education.history.deleted.succesfully": "Education history has been deleted succesfully",

    // Sofi UI
    "Location-Mapping-placeholder": "Please enter your desired location",
    "Calendly-Response": "Done",


    "body": "Your career buddy",
    "input_custom": "Type your message here",
    "first_message": "Sorry; I could not understand that! Could you please repeat?",
    "final_message": "I’m sorry, but I am having difficulty understanding your response. Press the reset button to continue completing your profile.",
    "slide_size": "{first_slide} of {last_slide}",
    "display_iframe.title": "Please take your test here",
    "display_profile.skillset": "Skillset",
    "display_profile.preferred_location": "Preferred Location",
    "display_profile.available_to_start": "Available to start",
    "display_profile.phone_number": "Phone Number",
    "display_profile.education": "Education",
    "input_calendy.heading.appointment": "Please schedule an appointment with the recruiter",
    "restart_conversation.title": "Start a new conversation",
    "restart_conversation.question": "All your previous conversations will be cleared. Are you ok to proceed?",
    "restart_conversation.btn.proceed": "Proceed",
    "restart_conversation.btn.cancel": "Cancel",
    "input_resume.title": "Select your files",
    "input_resume.subtitle": "Allowed file types: pdf, docx",
    "input_resume.file_size": "Max file size: 1 MB",
    "input_resume.upload_failed.bot_message_response": "No Skills in Resume",
    "input_resume.upload_failed.upload_resume_with_skill_message": "Please upload a valid resume with skills",
    "input_resume.upload_failed.upload_resume_message": "Please upload your resume here",
    "input_resume.btn.upload": "Upload",
    "input_resume.btn.cancel": "Cancel",
    "input_skill.placeholder": "Search for and add Skills",
    "input_skill.placeholderV2": "Add skills",
    "input_skill.tag_placeholder": "Do you want to add new Skill?",
    "input_skill.no_options": "One or more characters required for suggestions",
    "input_skill.btn_done": "Done",
    "input_skill.btn_cancel": "Cancel",
    "input_skill.added_skill_title": "Added Skills",
    "input_skill.no_skills_title": "No skills added yet",
    "input_skillv2.placeholder": "Add skill",
    "input_skillv2.add_skills": "Added skills",
    "input_skillv2.no_skills": "No skills added yet",
    "input_skillv2.btn_done": "Done",
    "input_skillv2.btn_cancel": "Cancel",
    "input_skillv2.new_skill": "Add {skill} as new skill",
    "input_skillv2.existing_skill": "Skill {skill} is already added",
    "input_text.placeholder": "Type your message here",
    "display_job.job_location": "Job Location",
    "display_job.job_type": "Job Type",
    "display_job.experience": "Experience",
    "display_job.min_experience": "{min_exp} years",
    "display_job.pay": "Pay",
    "display_job.job_skills": "Job Skills",
    "display_job.job_description": "Job Description",
    "display_job.apply_btn": "Apply",
    "input_comments.placeholder": "Type your message here",
    "input_email.placeholder": "someone@company.com",
    "input_recruiter.recruiter": "Please search by the recruiter's first name",
    "input_referral_source.tag_placeholder": "Do you want to add new Referral Source?",
    "input_referral_source.placeholder": "Search for and add Referral Source",
    "input_referral_source.no_options": "One or more characters required for suggestions",
    "input_salary.placeholder": "Please enter your desired annual salary",
    "input_states.tagPlaceholder": "Please enter the licensed states",
    "input_states.placeholder": "Search for and add new states",
    "input_states.no_result": "No states found. Please select a valid state form the list.",
    "splash_screen.contact_us_btn": "Contact us",
    "dropdown.default.placeholder": "Please select an option",
    "dropdown.default.input_desired_area.placeholder": "Please select your desired areas",
    "dropdown.default.input_desired_county.placeholder": "Please select your desired county",
    "dropdown.default.input_days_available.placeholder": "Please select the available days",
    "dropdown.default.input_age_range.placeholder": "Please select your age range",
    "dropdown.default.input_language.placeholder": "Please select your languages",
    "dropdown.default.input_area_of_experience.placeholder": "Please select your work setting",

    "utter_welcome": "I am Sofi, your career buddy. I offer the following services - \n1. Profile Creation \n2. Update Profile \n3. Job Search \n4. Appointment Scheduling \n5. Refer a Friend\n\nHow can I help you today?",
    "utter_services": "How can I help you today? \n1. Update profile\n2. Search jobs\n3. View profile\n4. Appointment scheduling\n5. Refer a Friend\n\nHow can I help you today?",
    "utter_logged_in_welcome": "How can I help you today? \n1. Update profile\n2. Search jobs\n3. View profile\n4. Appointment scheduling\n5. Refer a Friend\n\nHow can I help you today?",
    "utter_services_after_two_stage_fallback": "I am equipped to assist you in these topics: \n1. Profile Creation \n2. Update Profile \n3. Job search \n4. Appointment Scheduling \n5. Refer a Friend\n\nPlease choose from these options.",
    "utter_logged_in_services_after_two_stage_fallback": "I am equipped to assist you in these topics: \n1. Update Profile \n2. Job search \n3. Appointment Scheduling \n4. Answer FAQs about $$replace_company_name_from_config$$\n5. Refer a Friend\n\nPlease choose from these options.",
    "utter_ask_jobs_search_with_params": "Please enter the Job Search phrase. For example: \"Show me Java Developer Jobs in Austin, Texas\"",
    "utter_ask_jobs_search_with_params_error": "Please check the search phrase and re-enter",
    "utter_send_confirmation": "Great! You have successfully applied to {} role at $$replace_company_name_from_config$$. Please complete your job application <a href={} target=”_blank”>here</a>. You are required to take two assessments for this job.",
    "utter_send_confirmation_disabled_assessment": "Great! You have successfully applied to {} role at $$replace_company_name_from_config$$.",
    "utter_matching_jobs": "Here are the jobs recommended based on your profile",
    "utter_services_profile_completed_false": "Update My Profile",
    "utter_services_profile_completed_false_textv2": "View Profile",
    "utter_services_profile_completed_false_textv3": "Your profile is incomplete.\n Please add the missing information to your profile by clicking on the menu options below.",
    "utter_how_can_i_help": "Schedule interaction with recruiter",
    "utter_how_can_i_help_textv2": "Back to menu",
    "utter_how_can_i_help_textv3": "I can help you search for jobs, schedule appointments, perform skill assessments, and answer questions. If you need help with anything else, you can call (792)-221-1122 or email jobs@$$replace_company_name_from_config_email$$.com.",
    "utter_listing": "That’s understandable. We do have exciting new opportunities that may pique your interest, and this <a href=\"https://www.$$replace_company_name_from_config_email$$.com/company/careers/\" target=”_blank”>link</a> will take you to our most recent listings.",
    "utter_contact": "Sorry; I am not able to understand. Please call us at 770-691-5853 or email support@$$replace_company_name_from_config_email$$.com and we will assist you right away",
    "utter_iambot": "My name is Sofi - $$replace_company_name_from_config$$ Virtual Assistant.",
    "utter_iambot_textv2": "Yep, I'm a bot!",
    "utter_iambot_textv3": "Yes, I'm a bot.",
    "utter_iambot_textv4": "Yep, you guessed it, I'm a bot!",
    "utter_iambot_textv5": "I am indeed a bot 🤖",
    "utter_profile_create_greeting": "Congratulations {} 🎉!!! You are now part of $$replace_company_name_from_config$$ Talent Community. To learn more about our Talent Community, click <a href=\"{}/atsuser/signup\" target=”_blank”>here</a>",
    "utter_returning_user_greeting": "Welcome back {} ! We are glad you are a part of the $$replace_company_name_from_config$$ Talent Community.",
    "utter_out_of_scope": "Sorry, I am not able to understand. Please call us at 770-691-5853 or email support@$$replace_company_name_from_config_email$$.com and we will assist you right away.",
    "utter_ask_availability": "Now",
    "utter_ask_availability_textv2": "In 2 weeks - 1 Month",
    "utter_ask_availability_textv3": "In 1 - 3 Months",
    "utter_ask_availability_textv4": "After 3 Months",
    "utter_ask_availability_textv5": "Not Available",
    "utter_ask_availability_textv6": "Skip",
    "utter_ask_availability_textv7": "Super! How soon can you start a new position?",
    "utter_update_menu": "To make changes to specific fields in your profile simply enter the number For example, enter 2 to update skills:\n1. update phone \n2. update skills \n3. update resume",

    "utter_default": "I am really having trouble processing that.",
    "utter_thankyou": "No problem! You can schedule your appointment later.",
    "utter_enter_email": "Please enter your email.",
    "utter_email_invalid": "Please check you email and enter again.",
    "utter_confirm_scheduling": "Schedule Now",
    "utter_confirm_scheduling_textv2": "Skip",
    "utter_confirm_scheduling_textv3": "Would you like to Schedule a calendly meeting with recruiter?",
    "utter_thanks_for_scheduling": "Thank you {name} for scheduling an appointment. An email confirmation has been sent to you.",
    "utter_q_interested": "Yes",
    "utter_q_interested_textv2": "No",
    "utter_q_interested_textv3": "Ok great. I don't have your profile.\n\nWould you like to create one?",
    "utter_resume_upload": "Would you like to upload your resume?",
    "utter_ask_is_resume_upload": "Awesome! Would you like to share your resume and create a profile from it?",
    "utter_ask_is_resume_upload_for_jobs": "Would you like to share your resume so I can search jobs for you?",
    "utter_q_retry": "Would you like to retry?",
    "utter_require_info": "Okay, I would need some information to find the best jobs for you",
    "utter_ask_remote": "Are you able to work remote? Remote workers are required to have Internet access.",
    "utter_ask_name": "What is your First and Last Name? eg John Doe",
    "utter_ask_phone_number": "What is your 10 digit phone number? eg xxx xxx xxxx",
    "utter_ask_location": "What is your preferred work location?",
    "utter_ask_recruiter": "Please select the recruiter you are working with?",
    "utter_ask_resume_uploaded": "Great! Can you upload your resume?",
    "utter_ask_skillset": "Please enter or list your skills",
    "utter_profile_incomplete": "We are missing information about your {missing_info}",
    "utter_update_options": "Please choose the from the available buttons to update your profile.",
    "utter_profile_updated": "Great! Your profile is updated!",
    "utter_start": "Great! Let us get started",
    "utter_did_that_help": "Did that help you?",
    "utter_outofscope": "Sorry, I cannot understand that request at the moment",
    "utter_candidate_profile_form_out_of_scope": "Sure I can help you with that. But first finish creating your profile.",
    "utter_goodbye": "Thanks for chatting! Have a great day!",
    "utter_phone_number_error": "Oops! That's a invalid phone number.",
    "utter_amount_of_money_error": "Please enter a valid amount with a numeric value follwed by weekly, hourly.",
    "utter_amount_of_type_error": "Please enter a valid type of salary like weekly, hourly.",
    "utter_ask_rephrase": "Ok. Can you please rephrase your response?",
    "utter_ask_affirmation": "Did you mean?",
    "utter_matching_start": "I'm searching jobs matching your profile",
    "utter_q_end_convo": "Ok, Are you sure you want to end the chat session?",
    "utter_searchjob_fail_noresume": "Apologies, unable to search jobs without a resume.",
    "utter_anything_else": "Is there anything else I can help you with?",
    "utter_end": "Thank you for completing the conversation. Have a nice day!",
    "utter_thanks": "Thanks for the affirmation. Have a nice day!",
    "utter_sorry": "Apologies, We are not able to help you with that. Kindly reply if it's not an inconvenience to you!",
    "utter_ask_refer_friend_name": "I’m going to need a bit of information from you. First, what is your friend's first and last name?",
    "utter_ask_refer_friend_phone": "Great! What is {refer_friend_name}'s phone number?",
    "utter_ask_refer_friend_email": "Hang with me just a bit longer. What is {refer_friend_name}'s email?",
    "utter_ask_refer_friend_desc": "Why do you think {refer_friend_name} is a good candidate?",
    "utter_refer_a_friend_form_end": "Awesome! {refer_friend_name} has been referred and you will get paid once he is hired.",
    "utter_ask_refer_friend_is_recruiter": "Super, should {refer_friend_name} work with a recruiter you know?",
    "utter_ask_refer_friend_recruiter": "Ok. Select a recruiter from the list.",
    "utter_missing_info": "We are missing information about your {missing_info}.",
    "utter_exit_profile_update": "Thanks for updating your profile.",
    "utter_search_jobs_error": "Oops! There was an error in finding jobs.",
    "utter_search_jobs_apply_error": "Oops! there was a problem in applying for this job. Please try again.",
    "utter_search_jobs_forgot_resume_upload": "I am trying look for jobs matching your profile but I need your resume to search jobs.",
    "utter_profile_not_found": "Could not retrieve your profile",
    "utter_here_is_profile": "Here is your profile:",
    "utter_profile_is_incomplete": "Looks like you did not complete your profile. I can help you with that.",
    "utter_profile_missing_resume": "We are missing your resume",
    "utter_create_profile_account_exists": "There's already an account with these details. Kindly check again.",
    "utter_verification_code_not_sent": "Could not send verification code.",
    "utter_verification_code_expired": "Verification code has expired, a new one has been sent.",
    "utter_verification_code_invalid": "Please enter a valid numeric verification code, sent to your email",
    "utter_verification_code_incorrect": "resend",
    "utter_verification_code_incorrect_textv2": "Code was incorrect. Please enter the 6 digit verification code sent to your email.",
    "utter_verification_code_sent": "Please enter the 6 digit verification code sent to your email",
    "utter_weather": "Today's weather in {} is {} with a high of {} F and a low of {} F",
    "utter_standard_joke": "What's blue and not very heavy? Light blue.",
    "utter_city_invalid_weather": "The city you entered seems to be invalid. Can you ask for weather in a valid city instead?",
    "utter_fail_weather": "Sorry unable to get you the weather information",
    "utter_city_not_detected": "I did not find a city in your response. Can you ask for weather in a valid city instead? For example, here is the weather in Atlanta:",
    "utter_intro_joke": "Here is a joke for you!",
    "utter_fail_joke": "Sorry 🥺 unable to tell you a joke.",
    "utter_faq_low_confidence": "Sorry, I couldn't find and exact answer to your question. Did you mean to ask:",
    "utter_faq_error": "Sorry, There was an error in processing your query.",
    "utter_no_job_matches": "Uh oh! No jobs currently available for your profile.",
    "utter_show_top_n_jobs": "Showing top {} job matches.",
    "utter_show_top_n_jobs_outside": "Showing top {} job matches outside your desired work location.",
    "utter_job_select": "Please select a job by clicking on it.",
    "utter_error_search_jobs": "Oops! Looks like we lost connectivity...",
    "utter_job_confirmation_workllama": "Thanks for submitting your application to {} role at $$replace_company_name_from_config$$.",
    "utter_job_confirmation_workllama_textv2": "Thanks for submitting your application to {} role at $$replace_company_name_from_config$$.",
    "utter_session_expired": "Your session has expired, please refresh the page.",
    "utter_service_acknowledge": "Sure, I can help you with that! I need to know a couple of details about you to get started.",
    "utter_chitchat_options": "I can tell you a joke or the weather or who I am! What would you like to chat about?",
    "utter_invalid_time": "The day and time you entered looks to be invalid. Can you enter a valid day and time?",
    "utter_amount_of_money_numeric_error": "Please enter a valid amount with a numeric value.",
    "utter_amount_of_money_numeric_duration_error": "Please enter a valid amount with a numeric value per hour/week/year.",
    "utter_cancel_update": "You have cancelled the update for your {}.",
    "utter_update_thanks": "Thanks for updating your {}. I have updated your profile accordingly.",
    "utter_search_job_guest_flow": "I can search jobs for you! I need to know a couple of details about you to get started.",
    "utter_create_profile_guest_flow": "Sure, I can help you with profile creation! I need to know a couple of details about you.",
    "utter_schedule_calendly_guest_flow": "I can setup an appointment with a recruiter for you! I need to know a couple of details about you to get started.",
    "utter_update_profile_guest_flow": "I can help you with updating your profile! I need to know a couple of details to pull up your profile.",
    "utter_is_ask_more_input": "I need some more information to assist you better. Would you like to proceed?",
    "utter_decline_additional_info": "No problem. You can update them later.",
    "utter_ask_search_jobs": "Great! Would you like to see your job recommendations?",
    "utter_ask_years_of_experience": "How many years of experience do you have?",
    "utter_showing_jobs_for_experience": "Below are the jobs matching your work experience.",
    "utter_search_job_assessment_incomplete": "You have not finished the test. You would have received an email with the test link, please use it to finish the test at a later date.",
    "utter_experience_input_acknowledge": "Thank you for updating your work experience. I will recommend jobs for you based on your experience from now!",
    "utter_chat_history_display": "Below are our previous conversations:",
    "utter_chitchat_clarify": "Could you make a specfic request that I can help you with? ",
    "utter_ask_search_jobs_after_applying": "Would you like to see additional job recommendations?",
    "utter_exit_search_jobs": "Show more jobs",
    "utter_exit_search_jobs_textv2": "Exit Search Jobs",
    "utter_exit_search_jobs_textv3": "Please select a job",
    "utter_input_calendly": "Done",
    "utter_input_calendly_textv2": "Schedule later",
    "utter_welcome_topic": "Back to menu",
    "utter_welcome_topic_textv2": "I'm here to help with different questions you might have. Check out our popular topics below",
    "utter_ask_subtopic": "Here are some of the FAQ's under this topic",
    "utter_faq_menu": "Back to popular topics",
    "utter_faq_menu_textv2": "Back to menu",
    "utter_availability_start_date_error": "Please enter a future starting date.",
    "utter_ask_default_affirmation": "I am not quite sure if I understood correctly. Which of these did you mean? 🤔",

    // "NLU":",
    "assessments_inline": "end interview",

    // WLAPP INTENT MAPPING
    "resume_yes": "Resume/CV uploaded",
    "resume_false": "Resume upload cancelled",
    "affirm_availability": "Starting Now",
    "deny_availability": "Future Date",
    "done": "Done",
    "end": "End Conversation",
    "changes_to_profile": "Change Profile",
    "create_profile": "Create Profile",
    "search_jobs_with_params": "Search For Jobs",
    "view_profile": "View Profile",
    "schedule_calendly": "Schedule An Appointment",
    "skip_scheduling": "Schedule Later",
    "update_name": "Update Name",
    "update_phone": "Update Phone Number",
    "update_education": "Update Education",
    "update_availability": "Update Availability",
    "update_remote": "Update Remote Work Choice",
    "update_recruiter": "Update Recruiter",
    "update_location": "Update Location",
    "update_amount_of_money": "Update Desired Salary",
    "update_sponsorship": "Update Sponsorship Requirement",
    "update_resume": "Update Resume/CV",
    "update_skillset": "Update Skillset",
    "update_title": "Update Title",

    "exceeded.number.of.attempts": "You exceeded number of attempts",
    "phone.number.changed.success": "Phone number changed successfully",
    "ResumeDetails_UploadResumeError": "Error uploading resume",
    "check-your-inbox-to-validate-email": "Check your inbox to validate the email",
    "activation-link-resent-successfully": "Activation link is re-sent successfully to your registered email id",
    "gsu.were-you-referred.info-updated-text": "Your Referrer info has been updated",
    "gsu.were-you-referred.who-referred-you": "Who were you referred by?",
    "gsu.were-you-referred.yes-i-was-referred-to": "Yes, I was referred to { companyName }",
    "gsu.were-you-referred.no-i-found-on-my-own": "No, I found out about { companyName } on my own",
    "passport.document.upload.success": "Document has been uploaded successfully",
    "passport.document.delete.success": "Passport document has been deleted successfully",
    "passport.document.update.success": "Document details has been updated successfully",
    "passport.document.delete": "Delete this passport document?",
    "passport.country.removed.success": "Country has been removed from the list successfully",
    "passport.country.selected.success": "Country has been selected successfully",
    "passport.country.selected.already": "This country has been selected already.",
    "passport.delete.passport": "Delete this passport?",
    "forum-please-write-a-post": "Please write your post and try again!",
    "document-delete-error-msg": "Error in documnet deletion",
    "skillcard-confirm-delete-skill-header": "Remove skills?",
    "skillcard-confirm-delete-skill-message": "Are you sure remove skills?",
    "skill-already-selected-message": "Skill Already Selected",
    "skill-selection-error-message": "Skill Selection Failed",
    "myprofile-update-error": "Error in update profile. Please try again",
    "jobalert-saved-success-message": "Job Alert saved successfully.",
    "licence-activation-failed": "Licence Activation Failed",
    "licence-selected-success": "License Selected Successfully",

    "high-traffic-error": "We are experiencing high traffic, please try after some time.",

    "password-does-not-satisfy-min-requirement": "Password does not satisfy the minimum requirement!",
    "candidate-survey-text": "Candidate Survey",
    "timesheet-timeoff-hours": "Timeoff Hours",
    "timesheet-rejection-comment-text": "Rejection comment",
    "timesheet-approved-comment-text": "Approved comment",
    "timesheet-job-name-is-required": "Job Name is required",
    "timesheet-start-date-is-required": "Start date is required",
    "timesheet-client-name-is-required": "Client name is required",
    "timesheet-hours-cannt-exceed-24hs": "Hours per day cannot exceed 24hrs",
    "timesheet-select-a-monday-text": "Select a Monday",
    "sunday-day-text": "Sunday",

    "error.changing.phone.number": "Error while changing phone number",
    "enter.current.pay": "Enter current pay",
    "period.for.current.pay": "Enter period for current pay",
    "enter.currency.for.current.pay" : "Select currency for current pay",
    "saved.successfully" : "Saved Successfully",
    "workpreference.something.went.wrong": "Something went wrong. Please try again!",
    "error.fetching.workpreference": "Error on fetching work preference",
    "provide.atleast.one.desiredlocation":"Please provide atleast {desiredlocationcount} desired work location",
    "enter.desired.pay": "Enter desired pay",
    "enter.period.for.pay": "Enter period for pay",
    "enter.currency.for.desired.pay": "Select currency for desired pay",
    "provide.atleast.one.empPreference": "Please provide atleast {empPreferenceCount} employment preference",
    "provide.atleast.one.shiftpreference":"Please provide atleast {shiftpreferencecount} shift preference",

    "myprofile.address.updated.message": "Address has been updated",
    "myprofile.address.title": "Address",
    "myprofile.please-enter-address-line1": "Please enter your address line 1",
    "myprofile.please-enter-state": "Please enter your state",
    "myprofile.please-enter-city": "Please enter your city",
    "myprofile.please-enter-zip": "Please enter your zip",
    "myprofile.please-enter-password": "Please enter the password",
    "phone-number-has-been-updated": "Phone number has been updated",
    "invalid-ph-number-text": "Invalid Phone Number",
    "professionalReferences-referencename.required": "Reference Name is required",
    "professionalReferences-referencetitle.required": "Title is required",

    "MyJobListing_JobSavedSuccess": "Job Saved Successfully",
    "MyJobListing_JobUnsavevSuccess": "Job deleted from saved jobs",
    "global-continue-to-submit-app-btn": "Continue to Submit Job Application",
    "global-continue-to-submit-app-message": "Save & exit will take you to the home page. Don't worry your progress will be saved.<br /> OR <br />Continue to fill the rest of your details",

    "global-back-in-text": "Back in",
    "date-text": "Date",
    "myjobs-negotiable-text": "Negotiable",
    "myjobs-not-negotiable-text": "Not Negotiable",
    "report-this-post-text": "Report this post",
    "global-report-text": "Report",

    "confirm-are-you-sure-title": "Are you sure?",
    "skill-confirm-exit-without-saving": "Changes made will not be saved. \nAre you sure you want to exit skill checklist?",
    "skill-answers-saved-message": "Answers have been saved successfully",
    "source-details-saved-message": "Source details are saved successfully",
    "source-details-not-saved-message": "Source details are not saved",
    "jobalert-confirm-delete-message": "Delete Job Alert?",
    "jobalert-frequency-updated-message": "Job Alert Frequency Updated Successfully!",
    "jobalert-frequency-updated-failed": "Job Alert Frequency Updation Failed!",
    "account-disabled-header": "Account disabled",
    "account-disabled-message": "Your account has been disabled by our administrator.",
    "please-reach-out-to-us-at": "Please reach out to us at",
    "confirm-leave-survey": "Leave Survey?",
    "confirm-leave-survey-message": "You have unsaved changes on this Survey. If you leave now, your changes will be lost. Are you sure you want to continue?",
    "leave-survey-action": "Leave Survey",
    "stay-on-survey-action": "Stay on Survey",
    "confirm-changes-text": "Confirm Changes?",
    "confirm-and-close-text": "Confirm and close survey",
    "go-back-and-change-answer-text": "Go back and change answer",
    "confirm-changes-invalid-message": "You have updated your existing email ID or phone number while completing this survey. Please check these changes are correct.",
    "confirm-changes-save-message": "You have updated your existing email ID or phone number while completing this survey. Please confirm if these changes are correct.",
    "survey-can-go-ahead-text": "You can go ahead and find jobs",
    "placeholder.select-a-country": "Select a Country",

    "global.and.text": "and",
    "PasswordIndicator_PasswordMustContainText": "Password must contain",
    "verfication.otp.didnotgetcode": "Did not get the code?",
    "verfication.otp.type.email": "email.",
    "verfication.otp.type.textmessage": "text message.",

    "protected-info.add.protected.info.header": "No Information Added Yet",
    "protected-info.add.protected.info.subheader": "Please add protected information to your profile",
    "protected-info.add.protected.info.link": "Add Protected Information",
    "socialprofile.user.plus.to.add.social.profile": "Use the + button to add the social profile",
    "socialprofile.updated.successfully": "Updated Social profiles",
    "time.zone": "Time Zone",
    "address.lookup": "Address Lookup",
    
    "jobconstants.application.received": "Your job application has been received",
    "jobconstants.screening": "Your application is being screened",
    "jobconstants.shortlisted" : "Congratulations! You have been shortlisted for the position",
    "jobconstants.candidate.submitted": "Your profile has been submitted for further consideration",
    "jobconstants.interview": "You’ve been selected for an interview",
    "jobconstants.review": "Your application is being reviewed",
    
    "jobconstants.application.applied": "APPLICATION SUBMITTED",
    "jobconstants.application.screening": "SCREENING",
    "jobconstants.application.shortlisted" : "SHORTLISTED",
    "jobconstants.application.candidate.submitted": "CANDIDATE SUBMITTED",
    "jobconstants.application.interview": "INTERVIEW",
    "jobconstants.application.review": "REVIEW",

    "jobapplyflow.add.supporting.document": "Add supporting document",
    "jobapplyflow.docdoesnotexpire": "This document does not expire",
    "jobapplyflow.replace": "REPLACE",

    "jobs.successfully.applied": "Successfully Applied!",
    
    "data.and.privacy": "Data And Privacy Settings",
    "old.password.required": "Old Password required!",
    "referafriend.lastname.validation.error" :"Last name can only contain letters and should contain more than 2 characters"
    , "searchbox.for.text": "for",
    "referrals.copied": "copied!",
    "referrals.unable.to.copy": "unable to copy!",
    "bookmark.this.job.text": "Bookmark the job",
    "jobs.footer.pagination.of.text": "of",
    "jobs.footer.pagination.page.text": "page",
    "jobalert.all.jobs": "All Jobs",
    "no.special.characters.allowed.firstname": "No special Characters or fonts are allowed for First name",
    "no.special.characters.allowed.lastname": "No special Characters or fonts are allowed for Last name",
    "no.special.characters.allowed.preferredname" : "No special Characters or fonts are allowed for Preferred name",
    "searchbox.in.and.around.text": "in and around",
    "jobshare.already.registered.text": "Hey! Looks like you are registered with us. Please login to continue referring",
    "quicksignup.already.registered.text": "Hey! Looks like you are registered with us",
    "terms.of.service.text": "Terms of service",
    "privacy.policy.text" :"Privacy policy", 
    "jobDetail.shareLinkEmailSubject": "Check out this job: {jobName}",
    "jobDetail.shareLinkEmailBody": "Hi,\n\nI've found a job that might interest you. Check it out at the link below:\n\n {shareLink}\n\nThanks!",
    "bot.help.text": "How may I help you today?",
    "file-size-cannot-exceed-two-mb" : "File size cannot exceed 2 mb",

    // error messages and success messages
    "errorcode.2100" : "FirstName or LastName can not contain whitespaces only",
    "errorcode.2101" : "Please enter valid Referral code",
    "errorcode.1020" : "Could not acquire linkedin profile data with with payload provided!",
    "errorcode.1010" : "Error attempting to obtain getToken. Please validate payload",
    "errorcode.2102" : "A user with this phone number already exists. Please try a different phone number",
    "errorcode.2103" : "This email address is already in use. Please try a different email address",
    "errorcode.2104" : "User Name not valid",
    "errorcode.2105" : "Skill not valid",
    "errorcode.2106" : "Failed",
    "errorcode.2107" : "New Password and Confirm Password do not match. Please check and try again",
    "errorcode.2108" : "Temporary Password does not match what was sent to your email",
    "errorcode.2109" : "Permission not allowed!",
    "errorcode.2110" : "Resume not found!",
    "errorcode.2111" : "Email id not exist",
    "errorcode.2112" : "You have registered through social media. Login using the social media icon you used to register",
    "errorcode.2113" : "INVALID_ENTRY",
    "errorcode.2117" : "It looks like your account has been locked. Please contact support for assistance.",
    "errorcode.2118" : "Send reset email to user failed",
    "errorcode.1001" : "UserAttributeMaster is not found.",
    "errorcode.1004" : "No document has been uploaded for the given attribute",
    "errorcode.1002" : "UserAttributeMapping is not found.",
    "errorcode.1005" : "Unable to persist attribute for skill.",
    "errorcode.2114" : "Invalid File Content",
    "errorcode.2115" : "Unable to process the request. Please try later",
    "errorcode.2116" : "please login with your registered email address to continue",
    "errorcode.2119" : "Registration url not generated",
    "errorcode.2020" : "This Phone Number is already registered with another email ID",
    "errorcode.2121" : "PasswordRecord can not be null or empty",
    "errorcode.2122" : "There was an issue with your document. Please check the file's name, format, and size, and try again.",
    "errorcode.1518" : "Password entered does not match with records",
    "errorcode.1519" : "This Email Address is already registered with another user",
    "errorcode.1193" : "No history for UserJobHistoryList",
    "errorcode.1599" : "Referee's email address or phone number is same as the Referrer",
    
    "errorcode.1121" : "Job Posting not found",
    "errorcode.1122" : "Sorry! This job is not available",
    "errorcode.1127" : "This job posting has been cancelled. Please apply to other jobs.",
    "errorcode.1128" : "Sorry! This job is currently unavailable",
    "errorcode.1123" : "This job posting has been cancelled. Please apply to other jobs.",
    "errorcode.1129" : "Sorry! This job is no longer available. Please click on OK button to see other jobs.",
    "errorcode.1124" : "This job has been filled. Please apply to other jobs.",
    "loading-spinner" : "Loading, Please wait....",
    "error-ph-verification":"Verification Code entered is invalid",
    "referral-label":"Referral",
      // success messages
    
   "resume-renamed-success" : "Resume Renamed Successfully!",
   "resume-delete-success" : "Resume Deleted Successfully!",

   "New-Password-and-Confirm-Password-do-not-match.-Please-check-and-try-again." : "New Password and Confirm Password do not match. Please check and try again.",
   "You-have-used-this-password-earlier.-Please-enter-a-new-password" : "You have used this password earlier. Please enter a new password",
   "Sorry,-the-old-password-you-entered-is-incorrect.-Please-check-and-try-again.":"Sorry, the old password you entered is incorrect. Please check and try again.",
   "Invalid-username-or-password." : "Invalid username or password.",
   "Invalid-password.-Your-next-unsuccessful-attempt-will-lock-your-account." : "Invalid password. Your next unsuccessful attempt will lock your account.",
   "Your-account-has-been-locked.-To-unlock-your-account,-please-reset-your-password-using-Forgot-Password." : "Your account has been locked. To unlock your account, please reset your password using Forgot Password.",
   "sent-activation-link" : "{companyname} has sent an activation link to your registered email id {emailid}",
   "ph-number-already-registered":"This Phone Number is already registered with another user",
   "global-profile-picture" : "Profile picture",
   "Email-is-empty!" : "Email is empty!",
   "This-email-address-is-already-in-use.-If-this-belongs-to-you,-please-login-instead" : "This email address is already in use. If this belongs to you, please login instead",
   "This-email-address-is-already-in-use.-Please-try-a-different-email-address." : "This email address is already in use. Please try a different email address.",
   "An-account-with-this-phone-number-already-exists.-Please-try-a-different-phone-number-or-try-to-login" : "An account with this phone number already exists. Please try a different phone number or try to login",
   "An-account-with-this-email-address-already-exists.-Please-try-a-different-email-address-or-try-to-login" : "An account with this email address already exists. Please try a different email address or try to login",
   "This-email-address-is-already-in-use.-If-this-belongs-to-you,-check-your-inbox-for-a-registration-email-to-complete-your-account-or-login" : "This email address is already in use. If this belongs to you, check your inbox for a registration email to complete your account or login",
   "This-phone-number-is-already-in-use.-If-this-belongs-to-you,-check-your-inbox-for-a-registration-email-to-complete-your-account-or-login" : "This phone number is already in use. If this belongs to you, check your inbox for a registration email to complete your account or login",
   "This-email-address-is-already-in-use.-If-this-belongs-to-you,-please-complete-your-account-by-signing-up" : "This email address is already in use. If this belongs to you, please complete your account by signing-up",
   "Recruiter-Not-Specified" :"Recruiter Not Specified",
   "Work-Experience-record-already-exists" : "Work Experience record already exists",
   "raf-phone-number-exists":"This phone number is already in use by a different candidate. Please use a different phone number.",
   "raf-email-exists":"Sorry! We are already working with {friendfullname}. Please refer another candidate.",
   "preferred-language-text":"Preferred Langauge",
   "edit-language-setting":"Edit Language Setting",
   "jobrolesignup.pilot.totalHours.integerOnly":"Decimal values are not allowed for Total Flight hours.",
   "jobrolesignup.pilot.totalHours.negativeNotAllowed" : "Please enter only positive flight hours."

  },
};

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
});
